/* eslint-disable camelcase */
import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import { css, StyleSheet } from 'aphrodite';

import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import async from 'async';
import moment from 'moment-timezone'
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Helper } from '../../../common/helpers/Helper';
import { UiHelper } from '../../../common/helpers/UiHelper';
import { AppConfig } from '../../../AppConfig';
import { BaseEntityPageSlixta } from '../../../components/BaseEntityPageSlixta';
import { SearchBar } from '../../../common/components/SearchBar';
import { StatCard } from '../../../common/components/StatCard';
import { Controller } from '../../../common/Controller';
import DynamicFeedOutlinedIcon from '@material-ui/icons/DynamicFeedOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { TabChartCard } from '../../../common/components/charts/TabChartCard';
import { AppButton } from '../../../common/components/AppButton';
import { Badge, Checkbox, Fab, FormControlLabel, IconButton, MenuItem, Select, Switch } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { CdpHelper } from '../../../helpers/CdpHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { CrmContact } from './CrmContact';
import { PageDialog } from '../../../common/components/PageDialog';
import { DynamicFormDialog } from '../../../common/components/DynamicFormDialog';
import { CRMHelper } from '../../../helpers/CRMHelper';
import { UniBox } from '../../../common/components/UniBox';
import { FilterHelper } from '@slx/slixta-common';
import { CustomToggleButton } from '../../../common/components/CustomToggleButton';
import { TabsView } from '../../../common/components/TabsView';
import { SortByDialog } from '../../../common/components/SortByDialog';
import { StaffHelper } from '../../../common/helpers/StaffHelper';
import { ContactsFinder, startContactFinderImport } from './ContactsFinder';

function getImportFieldDef(staffUsers, currentStaffUser, crmcontactFieldDef, orgId, subOrgId) {
  const tagsField = Helper.getField(crmcontactFieldDef, 'tags')
  const timeZoneField = Helper.getField(crmcontactFieldDef, 'timeZone')
  const fieldDef = {
    title: 'Import',
    ctaButtonText: 'Import',
    steps: [
      {
        fields: [
          {
            key: 'importCsv',
            linkName: 'importCsvLink',
            type: 'document',
            subType: 'document',
            label: 'Import CSV',
            tip: 'Select a csv file to bulk import up to 100 contacts; Supported fields are \'email\', \'phone\', \'company\', \'firstname\', \'lastname\', \'tags\', \'linkedinurl\', \'jobtitle\', \'timezone\', \'leadstate\'; By default all contacts will be imported with state PROSPECT',
            tipLink: {
              title: 'Sample File',
              src: AppConfig.BULK_IMPORT_SAMPLE_FILE_URL
            },
            v_required: { value: true, err: 'Provide csv file' },
            placement: 'left',
            documentUpload: true,
            fileSizeLimit: 1048576,
            uploadAccept: 'text/csv',
          },
          {
            key: 'updateExisting',
            type: 'radio',
            label: 'Update Existing',
            tip: 'Disable this if you do not want existing CRM contacts to be updated',
            options: [{key: 'YES', label: 'YES'}, {key: 'NO', label: 'NO'}],
            v_required: {
              value: true,
              err: 'Choose a value'
            },
            placement: 'right',
            defaultValue: 'NO',
          },
          {
            key: 'csvMapping',
            linkName: 'csvMappingLink',
            type: 'document',
            subType: 'document',
            label: 'CSV Mapping',
            tip: 'Optionally provide a csv file to map the fields of your input csv to supported fields in Slixta',
            v_required: { value: false, err: 'Provide csv mapping file' },
            placement: 'left',
            documentUpload: true,
            fileSizeLimit: 1048576,
            uploadAccept: 'text/csv',
          },
          {
            key: 'title',
            type: 'edit_text',
            label: 'Import Job Title',
            tip: 'Optionally assign a title to this importing job',
            v_required: {
              value: false,
              err: 'Provide job title'
            },
            placement: 'right'
          },
          {
            condition: { key: 'updateExisting', value: 'NO', values: ['NO'] },
            key: 'defaultLeadState',
            type: 'radio',
            label: 'Default Lead State',
            tip: 'Optionally provide the default lead state for new contacts',
            options: [{key: 'PROSPECT', label: 'PROSPECT'}, {key: 'NEW', label: 'NEW'}],
            defaultValue: 'PROSPECT',
            v_required: {
              value: true,
              err: 'Provide default lead state'
            },
            placement: 'left'
          },
          {
            condition: { key: 'updateExisting', value: 'NO', values: ['NO'] },
            key: 'assignee',
            type: 'radio',
            label: 'Default Assignee',
            tip: 'Optionally provide the default assignee for new contacts',
            options: [],
            v_required: {
              value: false,
              err: 'Provide Assignee'
            },
            placement: 'right'
          },
          {
            condition: { key: 'updateExisting', value: 'NO', values: ['NO'] },
            key: 'defaultTimezone',
            type: 'radio',
            label: 'Default Timezone',
            tip: 'Optionally provide a default timezone for new contacts',
            options: timeZoneField && timeZoneField.options ? timeZoneField.options : [],
            v_required: {
              value: false,
              err: 'Provide Default Timezone'
            },
            placement: 'left'
          },
          {
            condition: { key: 'updateExisting', value: 'NO', values: ['NO'] },
            key: 'defaultTags',
            type: 'check_box',
            label: 'Default Tags',
            tip: 'Optionally provide default tags for new contacts',
            options: tagsField && tagsField.options ? tagsField.options : [],
            v_required: {
              value: false,
              err: 'Provide Default Tags'
            },
            placement: 'right'
          },
          {
            condition: { key: 'updateExisting', value: 'NO', values: ['NO'] },
            key: 'verifyEmails',
            type: 'radio',
            label: 'Verify Emails',
            tip: 'Disable this to skip email verification for new contacts',
            options: [{key: 'YES', label: 'YES'}, {key: 'NO', label: 'NO'}],
            v_required: {
              value: true,
              err: 'Choose a value'
            },
            placement: 'left',
            defaultValue: 'YES',
            advanced: true,
          },
        ]
      }
    ]
  }
  if (AppHelper.isABMEnabled(orgId)) {
    // Advanced: only Link Accounts is shown; create/email-domain defaults applied on submit
    fieldDef.steps[0].fields.push({
      key: 'linkAccounts',
      type: 'radio',
      label: 'Link Accounts',
      tip: 'Enable this to link contacts to accounts during import (account key must be provided)',
      options: [{key: 'YES', label: 'YES'}, {key: 'NO', label: 'NO'}],
      v_required: {
        value: true,
        err: 'Choose a value'
      },
      placement: 'left',
      defaultValue: 'YES',
      advanced: true,
    })
  }
  UiHelper.populateOptions(fieldDef, {items: StaffHelper.uniqueStaffByUserId(staffUsers)}, 'assignee')
  if (currentStaffUser && currentStaffUser.id) {
    const assigneeField = fieldDef.steps[0].fields.find(f => f.key === 'assignee')
    assigneeField.defaultValue = currentStaffUser.id
  }
  return fieldDef
}

function applyTeamsUnifiedAssignedTeamRequired(fieldDef, teamsUnifiedView, teamsEnabled) {
  if (!teamsUnifiedView || !teamsEnabled || !fieldDef) {
    return
  }
  const assignedTeamField = Helper.getField(fieldDef, 'subOrgId')
  if (assignedTeamField) {
    assignedTeamField.v_required = { ...assignedTeamField.v_required, value: true }
  }
}

function getExportFieldDef(orgId) {
  const includeAllTime = AppHelper.isSettingEnabled(orgId, 'CRM_EXPORT_ALL_TIME')
  const useDateRange = AppHelper.isSettingEnabled(orgId, 'CRM_EXPORT_DATE_RANGE')

  function getExportMonths() {
    const MAX_MONTHS = 12
    const result = [];
    for (let i = 0; i < MAX_MONTHS; i++) {
      const m = moment().subtract(i, 'months');
      result.push({
        label: m.format('MMMM, YYYY'),
        key: m.format('MMYYYY')
      });
    }
    return result;
  }

  const exportOptions = getExportMonths()

  if (useDateRange) {
    exportOptions.push({key: 'date_range', label: 'Custom Date Range'})
  } else if (includeAllTime) {
    exportOptions.unshift({key: 'all_time', label: 'All Time'})
  }

  const availableDateRanges = ['today', 'yesterday', 'this_week', 'this_month', 'last_30d', 'last_90d']

  const monthField = {
    key: 'mmyyyy',
    type: 'radio',
    label: 'Month',
    tip: 'Choose the month in which contacts were created',
    options: exportOptions,
    v_required: {
      value: true,
      err: 'Choose a month'
    },
    placement: 'left',
    defaultValue: exportOptions[0].key,
  }

  const fieldDef = {
    title: 'Export',
    ctaButtonText: 'Export',
    steps: [
      {
        fields: [monthField]
      }
    ]
  }

  if (useDateRange) {
    fieldDef.steps[0].fields.push(
      {
        condition: { key: 'mmyyyy', values: ['date_range'] },
        key: 'exportMode',
        type: 'radio',
        label: 'Filter by',
        tip: 'Filter contacts by created or modified date',
        options: [
          { key: 'CREATED', label: 'CREATED' },
          { key: 'MODIFIED', label: 'MODIFIED' },
        ],
        v_required: {
          value: true,
          err: 'Choose a mode'
        },
        placement: 'left',
        defaultValue: 'CREATED',
        advanced: true,
      },
      {
        condition: { key: 'mmyyyy', values: ['date_range'] },
        key: 'exportDateRange',
        type: 'dateRange',
        label: 'Date Range',
        tip: 'Choose the date range for export',
        availableDateRanges,
        timezone: Helper.getLocalTimezone(),
        v_required: {
          value: true,
          err: 'Choose a date range'
        },
        placement: 'right',
      }
    )
  }

  return fieldDef
}

function getProspectFieldDef(staffUsers, currentStaffUser, orgId, subOrgId) {
  const fieldDef = {
    title: 'Prospect',
    ctaButtonText: 'Next',
    steps: [
      {
        fields: [
          {
            key: 'prospectSource',
            type: 'radio',
            label: 'Source',
            tip: 'Select a prospect source',
            v_required: { value: true, err: 'Provide prospect source' },
            placement: 'left',
            options: [
              {key: 'linkedin', label: 'LINKEDIN'},
              {key: 'website', label: 'WEBSITE'},
            ],
            defaultValue: 'linkedin',
          },
          {
            condition: { key: 'prospectSource', value: 'linkedin', values: ['linkedin'] },
            key: 'linkedinProfileUrl',
            type: 'edit_text',
            label: 'LinkedIn Profile Url',
            tip: 'Paste the link to the LinkedIn profile of the person you want to prospect',
            v_required: { value: true, err: 'Provide LinkedIn profile url' },
            placement: 'right'
          },
          {
            condition: { key: 'prospectSource', value: 'website', values: ['website'] },
            key: 'companyWebsiteUrl',
            type: 'edit_text',
            label: 'Company Website Url',
            tip: 'Paste the link to the company website of the person you want to prospect',
            v_required: { value: true, err: 'Provide company website url' },
            placement: 'right'
          },
          {
            condition: { key: 'prospectSource', value: 'website', values: ['website'] },
            key: 'givenname',
            type: 'edit_text',
            label: 'First Name',
            tip: 'Enter the first name of the person you want to prospect',
            v_required: { value: true, err: 'Provide first name' },
            placement: 'left'
          },
          {
            condition: { key: 'prospectSource', value: 'website', values: ['website'] },
            key: 'familyname',
            type: 'edit_text',
            label: 'Last Name',
            tip: 'Enter the last name of the person you want to prospect',
            v_required: { value: true, err: 'Provide last name' },
            placement: 'right'
          },
          {
            condition: { key: 'prospectSource', value: 'email', values: ['email'] },
            key: 'email',
            type: 'edit_text',
            label: 'Email',
            tip: 'Enter the email of the person you want to prospect',
            v_required: { value: true, err: 'Provide email' },
            v_email: { value: true, err: 'Provide a valid email' },
            placement: 'right'
          },
          {
            condition: { key: 'prospectSource', value: 'csv', values: ['csv'] },
            key: 'importCsv',
            linkName: 'importCsvLink',
            type: 'document',
            subType: 'document',
            label: 'Import CSV',
            tip: 'Select a csv file to bulk prospect up to 100 leads; Supported fields are \'email\', \'linkedinurl\', \'firstname\', \'lastname\', \'companyurl\'; Please re-import the generated CSV file after review',
            tipLink: {
              title: 'Sample File',
              src: AppConfig.BULK_PROSPECT_SAMPLE_FILE_URL,
            },
            v_required: { value: true, err: 'Provide csv file' },
            placement: 'right',
            documentUpload: true,
            fileSizeLimit: 1048576,
            uploadAccept: 'text/csv',
          },
          {
            condition: { key: 'prospectSource', value: 'csv', values: ['csv'] },
            key: 'assignee',
            type: 'radio',
            label: 'Default Assignee',
            tip: 'Optionally assign the imported contacts to a staff member',
            options: [],
            v_required: {
              value: false,
              err: 'Provide default assignee'
            },
            placement: 'left'
          },
          {
            condition: { key: 'prospectSource', value: 'csv', values: ['csv'] },
            key: 'title',
            type: 'edit_text',
            label: 'Import Job Title',
            tip: 'Optionally assign a title to this prospecting job',
            v_required: {
              value: false,
              err: 'Provide job title'
            },
            placement: 'right'
          },
        ]
      }
    ]
  }
  if (AppHelper.isBulkProspectCsvEnabled(orgId)) {
    const prospectSourceField = Helper.getField(fieldDef, 'prospectSource')
    prospectSourceField.options.unshift({key: 'csv', label: 'CSV'})
    prospectSourceField.defaultValue = 'csv'
  }
  UiHelper.populateOptions(fieldDef, {items: StaffHelper.uniqueStaffByUserId(staffUsers)}, 'assignee')
  // if (currentStaffUser && currentStaffUser.id) {
  //   const assigneeField = fieldDef.steps[0].fields.find(f => f.key === 'assignee')
  //   assigneeField.defaultValue = currentStaffUser.id
  // }
  return fieldDef
}

function getSaveSegmentFieldDef(segments) {
  const fieldDef = {
    formType: 'add',
    title: 'Save Segment',
    ctaButtonText: 'Save',
    steps: [
      {
        fields: [
          {
            key: '_chosenSegment',
            type: 'radio',
            label: 'Choose Segment',
            tip: 'Save as new segment or overwrite an existing segment',
            v_required: { value: true, err: 'Choose a segment' },
            placement: 'left',
            options: [],
            defaultValue: '_new',
          },
          {
            condition: { key: '_chosenSegment', value: '_new', values: ['_new'] },
            key: 'title',
            type: 'edit_text',
            label: 'Segment Nickname',
            tip: 'Nickname of the new segment',
            v_required: { value: true, err: 'Provide a segment nickname' },
            placement: 'left',
          },
        ]
      }
    ]
  }
  UiHelper.populateOptions(fieldDef, {items: segments}, '_chosenSegment')
  fieldDef.steps[0].fields.find(f => f.key === '_chosenSegment').options.unshift({key: '_new', label: '[Save as New Segment]'})
  return fieldDef
}

function getSaveFilterFieldDef(customFilters) {
  const fieldDef = {
    formType: 'add',
    title: 'Save Filter',
    ctaButtonText: 'Save',
    steps: [
      {
        fields: [
          {
            key: '_chosenFilter',
            type: 'radio',
            label: 'Choose Filter',
            tip: 'Save as new filter or overwrite an existing custom filter',
            v_required: { value: true, err: 'Choose a filter' },
            placement: 'left',
            options: [],
            defaultValue: '_new',
          },
          {
            condition: { key: '_chosenFilter', value: '_new', values: ['_new'] },
            key: 'filterNickname',
            type: 'edit_text',
            label: 'Filter Nickname',
            tip: 'Nickname of the new filter',
            v_required: { value: true, err: 'Provide a filter nickname' },
            placement: 'left',
          },
        ]
      }
    ]
  }

  const options = (customFilters || []).map(f => ({ key: f.label, label: f.label }))
  options.unshift({ key: '_new', label: '[Save as New Filter]' })
  fieldDef.steps[0].fields.find(f => f.key === '_chosenFilter').options = options

  return fieldDef
}

function getExportFilteredFieldDef() {
  return {
    formType: 'add',
    title: 'Export Filtered Contacts',
    ctaButtonText: 'Export',
    steps: [
      {
        fields: [
          {
            key: 'title',
            type: 'edit_text',
            label: 'Export Job Title',
            tip: 'Optionally assign a title to this export job',
            v_required: { value: false, err: 'Provide job title' },
            placement: 'left',
          },
        ]
      }
    ]
  }
}

const EntityDialogLoading = () => UiHelper.componentLoadingView(true)

export class CrmContacts2 extends BaseEntityPageSlixta {

  constructor(props) {
    super(props);
    // this.noAdd = true
    this.emptyText = 'No results. Check your search query or search filters.'
    this.pageKey = 'crm-contacts'
    this.pageTitle = Helper.getString('crm-contacts')
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.subOrgId = Controller.get().userMgr().getSubOrgId(this.orgId)
    this.teamsUnifiedView = AppHelper.isTeamsUnifiedView(this.orgId)
    this.teamsEnabled = AppHelper.isTeamsEnabled(this.orgId)
    this.showLatestNote = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_SHOW_LATEST_NOTE')
    this.isLeadRoutingEnabled = !!AppHelper.getSetting(this.orgId, 'LEAD_ROUTING_TRIGGERS')
    this.staffUserId = Controller.get().getUserId()
    this.currentUser = this.staffUserId
    this.isMobileView = Helper.isMobileView()
    this.apiData = {
      orgId: this.orgId,
    }
    this.staffUsers = []
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute() },
      { title: this.pageTitle },
    ]
    this.attribsGroupId = 'settingscrmcontactattrs' + this.orgId

    this.xLabelsDifference = {
      today: 2,
      yesterday: 2,
      this_week: 1,
      this_month: 1,
      last_7d: 1,
      last_30d: 4,
      last_90d: 6,
      last_6m: 1,
      last_12m: 2,
      current_7d: 1,
      current_30d: 4,
      current_90d: 6,
      current_6m: 1,
      current_12m: 2,
      next_7d: 1,
    }
    this.dateMap = {
      today: '1h',
      yesterday: '1h',
      this_week: '1d',
      this_month: '1d',
      last_7d: '1d',
      last_30d: '1d',
      last_90d: '1d',
      last_6m: '1M',
      last_12m: '1M',
      current_7d: '1d',
      current_30d: '1d',
      current_90d: '1d',
      current_6m: '1M',
      current_12m: '1M',
      next_7d: '1d',
    }
    this.defaultDateInteval = {id: 'last_30d'}
    this.aggregationTermsLimit = 100
    this.showMoreLimit = 1000
    this.maxPaginationItems = 10000
    this.isFirstFetchNext = true

    this.restrictViewCrmFilters = {
      'tags!': 'INTERNAL',
    }
    if (AppHelper.isRestrictViewToAssignedContacts(this.orgId)) {
      this.restrictViewCrmFilters.assignee = this.staffUserId
    }
    this.toFetch = [
      { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId), pb: 'fieldDef,fieldDefBulkRouteCrmContact', includeCustomFields: 'true', limit: 100, ...this.restrictViewCrmFilters, _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.dateMap[this.defaultDateInteval.id], _aggTermsLimit: this.aggregationTermsLimit } },
      { key: 'crmcontactattrs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['items', `${this.attribsGroupId}-all`], queryParams: { orgId: this.orgId, groupId: this.attribsGroupId } },
      { key: 'usersORG', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-org-users2'], queryParams: {orgId: this.orgId, parentOrgId: this.orgId } },
      { key: 'usersME', method: 'GET', endPoint: ApiHelper.makeUrlPath(['users', 'me'], {}) },
      { key: 'crmsequences', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['campaigns'], queryParams: { orgId: this.orgId, iTypeState: 'DRIP-LIVE' } },
      { key: 'crminboxes', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crminboxs'], queryParams: { orgId: this.orgId, orgIdUserId: `${this.orgId}-${this.staffUserId}`, includeShared: 'true' } },
      { key: 'crmemailtemplates', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmemailtemplates'], queryParams: { orgId: this.orgId, pb: 'fieldDef', includeShared: 'true', limit: 200 } },
      { key: 'crmusersettings', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['items', `settingscrmusersettings${this.orgId}-${this.staffUserId}-all`], queryParams: { orgId: this.orgId, groupId: `settingscrmusersettings${this.orgId}-${this.staffUserId}` } },
      { key: 'crmbulkimportjobs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-crm-jobs'], queryParams: { orgId: this.orgId } },
      { key: 'crmaccountnames', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-crm-account-titles'], queryParams: { orgId: this.orgId } },
      { key: 'csegments', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['csegments'], queryParams: { orgId: this.orgId } },
    ]
    if (this.teamsEnabled && !this.subOrgId) {
      this.toFetch.push({ key: 'suborgs', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['miscs', 'get-sub-orgs'], queryParams: {orgId: this.orgId, parentOrgId: this.orgId } })
    }
    this.cellWidths = {
      Index: Styles.cellWidthSmall,
      Info: Styles.cellWidthNormal,
      Info2: Styles.cellWidthNormal
    }
    this.tableHeadersMap = {
      ...(this.isMobileView ? {} : {
        Index: (current) => current.__index + 1,
      }),
      Info: (current) => {
        let previewFields = null
        const contactPreviewTemplate = AppHelper.getSetting(this.orgId, 'CRM_CONTACT_PREVIEW_TEMPLATE')
        if(contactPreviewTemplate) {
          previewFields = contactPreviewTemplate.split('|')
            .map(part =>part.split(',')
              .map(item =>item.trim())
              .filter(item => item !== '')
            ).filter(arr => arr.length > 0)
        }
        const fieldDef = (previewFields && previewFields.flat().length > 0) ? this.contactPreviewFieldDef : null
        const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
        const displayTs = this.state.isUniboxBtnEnabled && uniboxSortKey && current[uniboxSortKey] ? current[uniboxSortKey] : current.createdTs
        return (
          <div>
            <Fragment>
              {previewFields &&  Array.isArray(previewFields) && previewFields.flat().length > 0 && CRMHelper.getPreviewFromFields(current,fieldDef,previewFields,displayTs)}
              {(!previewFields || previewFields.length === 0) && !this.isMobileView && CRMHelper.getContactInfoCellSpan(current)}
              {(!previewFields || previewFields.length === 0) && this.isMobileView && CRMHelper.getContactInfoCellSpanMobile(current, displayTs)}
              {!this.isMobileView && (!previewFields || previewFields.length === 0) && <br />}
            </Fragment>
            {!this.isMobileView && <Fragment>
              <span className={css(Styles.line3)}>{Helper.formatTimestamp(displayTs)}</span>
              <br />
            </Fragment>}
          </div>
        )
      },
      Info2: (current) => {
        const subOrg = this.subOrgs.find(s => s.id === current.subOrgId)
        const assigneeUser = CRMHelper.findStaffByAssignee(this.staffUsers, current.assignee)
        const assigneeName = assigneeUser ? Helper.formatName(assigneeUser) : ''
        const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
        const uniboxReadStatusKey = uniboxSortKey === 'activeIntSentTs' ? 'lastActiveIntSentStatus' : (uniboxSortKey === 'lastIntSentTs' ? 'lastIntSentStatus' : '')
        const isUniboxRead = current && uniboxReadStatusKey && (!current[uniboxReadStatusKey] || current[uniboxReadStatusKey] !== 'UNREAD')
        return (
          <div>
            {!current.lastWAMsgRecv && this.state.isUniboxBtnEnabled && current && !isUniboxRead &&
                <span className={css(Styles.uniBoxBadge)}>
                  <Badge overlap='circular' variant='dot' classes={{
                    badge: css(Styles.uniBoxBadgeDot),
                  }}/>
                </span>
            }
            {current.lastWAMsgRecv && this.state.isUniboxBtnEnabled && current &&
                <div className={css(Styles.line2, Styles.lastWAMsgBadge)}>
                  {!isUniboxRead && <span className={css(Styles.dot)} />}
                  <span className={css(Styles.lastWAMsgText)}>{current.lastWAMsgRecv}</span>
                </div>
            }
            {current.state &&
              <Fragment>
                <span className={current.state === 'CUSTOMER' ? css(Styles.line2, Styles.statusBadge, Styles.statusBadgeCustomer) : css(Styles.line2, Styles.statusBadge)}>{UiHelper.renameCRMContactLeadStatus(this.orgId,current.state)}</span>
              </Fragment>
            }
            {!this.isMobileView && current.source &&
              <Fragment>
                <span className={css(Styles.line2)}>Source: {current.source}</span>
                <br />
              </Fragment>
            }
            {!this.isMobileView && this.teamsEnabled && subOrg &&
              <Fragment>
                <span className={css(Styles.line2)}>Team: {subOrg.title}</span>
                <br />
              </Fragment>
            }
            {!this.isMobileView && assigneeName &&
              <Fragment>
                <span className={css(Styles.line2)}>Assignee: {assigneeName}</span>
                <br />
              </Fragment>
            }
            {!this.isMobileView && Array.isArray(current.tags) && current.tags.length > 0 &&
              <Fragment>
                <span className={css(Styles.line2)}>Tags: {current.tags.join(', ')}</span>
                <br />
              </Fragment>
            }
            {!this.isMobileView && this.showLatestNote && current.latestNote &&
              <Fragment>
                <span className={css(Styles.line2)}>Latest Note: {Helper.ellipsis(current.latestNote, 200)}</span>
                <br />
              </Fragment>
            }
          </div>
        )
      },
      // Profile: (current) => { return Helper.formatName(current) }
    }
    this.noTableHead = true

    this.headerActions = []
    if (!this.isMobileView && !this.subOrgId && AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACTS_CONTACTS_FINDER')) {
      this.headerActions.push({
        label: 'Find Contacts',
        tooltip: 'Find Contacts',
        icon: 'person_search',
        type: 'icon-label',
        onClick: () => this.openContactsFinderDialog(),
      })
    }
    this.headerActions.push({
      label: 'Add',
      tooltip: 'Add Contact',
      icon: 'person_add',
      type: 'icon-label',
      onClick: () => this.openModalForAdd(),
    })
    if (!this.isMobileView && !this.subOrgId) {
      this.headerActions.push({
        label: 'Import',
        tooltip: 'Import',
        icon: 'group_add',
        type: 'icon-label',
        onClick: () => {
          const fieldDef = getImportFieldDef(this.staffUsers, this.currentStaffUser, this.fieldDef, this.orgId, this.subOrgId)
          fieldDef.title = Helper.getString('importContacts')
          this.openModalForAdd(fieldDef)
        }
      })
    }
    this.headerActions.push({
      label: 'Refresh',
      tooltip: 'Refresh',
      icon: 'refresh',
      type: 'icon-label',
      onClick: () => this.fetchItems(),
    })

    this.state.isUniboxBtnEnabled = false
    this.state.isAutoRefreshEnabled = false
    this.state.searchFilters = {}
    this.state.filterOptions = []
    this.state.selectedTabData = {
      tabbedChart1: 0,
      tabbedChart2: 0,
    }
    this.state.sortKey = 'createdTs'
    this.state.sortOrder = 'desc'
    this.state.compactStatsTabSelected = 0
    this.state.availableTabs = []
    this.state.activeTabLabel = null
    this.state.userSortKey = null
    this.state.userSortOrder = null
    this.state.hasErrorLoadingTabs = false
    this.state.isSortByDialogOpen = false
    this.state.isContactsFinderDialogOpen = false
    this.state.sortByFormDefinition = null
    this.autoRefreshIntervalId = null
    this.isAutoRefreshPausedByDialog = false
    this.uploadMs = AppConfig.CDP_MS.ENDPOINT
    this.displayCheckBoxTable = !this.isMobileView
    this.checkboxTableItemNameSingular = 'contact'
    this.checkboxTableItemNamePlural = 'contacts'
    this.isHeaderActionsHidden = this.isMobileView ? true : false
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)
    const urlSortKey = urlParams.get('_sortKey')
    const urlSortOrder = urlParams.get('_sortOrder')

    if (urlSortKey) {
      this.state.userSortKey = urlSortKey
      this.state.sortKey = urlSortKey
    }
    if (urlSortOrder) {
      this.state.userSortOrder = urlSortOrder
      this.state.sortOrder = urlSortOrder
    }
    this.fetchItems()
  }

  componentWillUnmount() {
    this.unmounted = true
    this.stopAutoRefresh()
  }

  componentDidUpdate(prevProps, prevState) {
    const wasAnyDialogOpen = this.isAnyDialogOpen(prevState)
    const isAnyDialogOpen = this.isAnyDialogOpen(this.state)

    if (!wasAnyDialogOpen && isAnyDialogOpen && this.state.isAutoRefreshEnabled) {
      this.stopAutoRefresh()
      this.isAutoRefreshPausedByDialog = true
    } else if (wasAnyDialogOpen && !isAnyDialogOpen && this.isAutoRefreshPausedByDialog) {
      this.isAutoRefreshPausedByDialog = false
      if (this.state.isAutoRefreshEnabled) {
        this.startAutoRefresh()
      }
    }

  }

  fetchItems(onReadyCallback) {
    this.isFirstFetchNext = true
    super.fetchItems(onReadyCallback);
  }

  isAnyDialogOpen = (state = this.state) => {
    return !!(state.modalOpen || state.isCustomFiltersDialogOpen || state.isEntityDialogOpen || state.isContactsFinderDialogOpen || state.isContactsFinderImportOpen)
  }

  getActiveTabConfig = () => {
    if (!this.state.activeTabLabel || !this.state.availableTabs) {
      return null
    }
    return this.state.availableTabs.find(tab => tab.label === this.state.activeTabLabel)
  }

  isActiveInteractionsTab = () => {
    const activeTab = this.getActiveTabConfig()
    return !!(activeTab && activeTab.active)
  }

  startAutoRefresh = () => {
    this.stopAutoRefresh()
    this.autoRefreshIntervalId = setInterval(() => {
      const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
      const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions || []))
      const hasCustomTabs = Array.isArray(this.state.availableTabs) && this.state.availableTabs.length > 0
      const activeTabConfig = this.getActiveTabConfig()
      const isActiveTab = !!(activeTabConfig && activeTabConfig.active)
      const shouldPreserveStats = !(hasCustomTabs && isActiveTab)
      this.onSearch(this.state.searchText || '', searchFilters, filterOptions, ApiHelper.LOADING_MODE.INSTANT_LOAD, shouldPreserveStats)
    }, 30000)
  }

  stopAutoRefresh = () => {
    if (this.autoRefreshIntervalId) {
      clearInterval(this.autoRefreshIntervalId)
      this.autoRefreshIntervalId = null
    }
  }

  onAutoRefreshToggle = (event) => {
    const isAutoRefreshEnabled = !!event.target.checked
    this.setState({ isAutoRefreshEnabled }, () => {
      if (isAutoRefreshEnabled) {
        const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
        const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions || []))
        this.onSearch(this.state.searchText || '', searchFilters, filterOptions, ApiHelper.LOADING_MODE.INSTANT_LOAD)
        if (this.isAnyDialogOpen()) {
          this.isAutoRefreshPausedByDialog = true
        } else {
          this.startAutoRefresh()
        }
      } else {
        this.stopAutoRefresh()
        this.isAutoRefreshPausedByDialog = false
        const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
        const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions || []))
        this.onSearch(this.state.searchText || '', searchFilters, filterOptions, ApiHelper.LOADING_MODE.INSTANT_LOAD)
      }
    })
  }

  openInteractionsDialog(current) {
    if(current) {
      const hasCustomTabs = Array.isArray(this.state.availableTabs) && this.state.availableTabs.length > 0
      let selectWATab = false
      const isActiveInteractionsSelected = hasCustomTabs ? this.isActiveInteractionsTab() : !!this.state.isUniboxBtnEnabled
      const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
      const isWALatest = current.waIntSentTs && uniboxSortKey && (current[uniboxSortKey] === current.waIntSentTs)
      if (current.phone && AppHelper.isWAInteractionsViewEnabled(this.orgId)) {
        selectWATab = isActiveInteractionsSelected && isWALatest
      }

      const entityId = `${this.orgId}-${current.userId}`
      this.setState({
        entityDialogProps: {
          match: {params: {orgId: this.orgId, userId: current.userId}},
          hideAccountsButton: true,
          hideBreadCrumbs: true,
          isLogoForMobileHidden: true,
          isHeaderTitleHidden: true,
          hideHeaderbar: true,
          isActiveInteractionsSelected: isActiveInteractionsSelected,
          selectWATab: selectWATab,
          pageTitle: Helper.formatName(current),
          onMarkAsUnreadStart: () => this.setState({ isEntityDialogLoading: true }),
          onMarkAsUnreadSuccess: () => this.closeEntityDialog(entityId),
          onMarkAsUnreadError: () => this.setState({ isEntityDialogLoading: false }),
          cachedData: {
            crmUser: current,
            crmUserFieldDef: (this.crmContactsResult && this.crmContactsResult.fieldDef) ? this.crmContactsResult.fieldDef : null,
            accountFieldDef: this.accountFieldDef || ((this.crmContactsResult && this.crmContactsResult.accountFieldDef) ? this.crmContactsResult.accountFieldDef : null),
            usersOrg: this.staffUsers,
            crmInboxes: this.crmInboxes,
            crmSequences: this.crmSequences,
            crmAccountNames: this.crmAccountNames,
            crmUserSettings: this.crmUserSettingsResult,
            crmEmailTemplates: this.crmEmailTemplatesResult,
            crmContactAttrs: this.crmContactAttrs,
            crmContactsStats: this.crmContactsStats,
            subOrgs: this.subOrgsResult,
          }
        },
        entityId,
        isEntityDialogOpen: true,
        isEntityDialogLoading: false,
        entityDialogFullHeight: true,
        entityDialogFullWidth: true,
        entityDialogTitle: Helper.formatName(current),
      })
    }
  }

  getXLabelsDifference(timezone) {
    let xLabelsDifference = this.xLabelsDifference[this.defaultDateInteval.id]
    if(this.state && this.state.searchFilters && this.state.searchFilters.createdTs && this.state.searchFilters.createdTs.id) {
      if(this.state.searchFilters.createdTs.id === 'custom') {
        const countOfDays = CRMHelper.getCountOfDaysInCustomDateRange(this.state.searchFilters.createdTs, timezone)
        if (countOfDays === 1) {
          xLabelsDifference = 2
        } else if (countOfDays <= 7) {
          xLabelsDifference = 1
        } else if (countOfDays <= 30) {
          xLabelsDifference = 4
        }  else if (countOfDays <= 90) {
          xLabelsDifference = 6
        } else if (countOfDays <= 180) {
          xLabelsDifference = 1
        } else if (countOfDays <= 365) {
          xLabelsDifference = 2
        } else {
          xLabelsDifference = 1
        }
      } else {
        xLabelsDifference = this.xLabelsDifference[this.state.searchFilters.createdTs.id]
      }
    }
    return xLabelsDifference
  }

  getDateInterval(searchFilters, timezone) {
    let dateInterval = this.dateMap[this.defaultDateInteval.id]
    if(searchFilters && searchFilters.createdTs && searchFilters.createdTs.id) {
      if(searchFilters.createdTs.id === 'custom') {
        const countOfDays = CRMHelper.getCountOfDaysInCustomDateRange(searchFilters.createdTs, timezone)
        if (countOfDays === 1) {
          dateInterval = '1h'
        } else if (countOfDays > 90) {
          dateInterval = '1M'
        }
        else{
          dateInterval = '1d'
        }
      } else {
        dateInterval = this.dateMap[searchFilters.createdTs.id]
      }
    }
    return dateInterval
  }

  fetchItem() {
    this.apiStartTs = Helper.currentTs()
    const orgIdUserId = this.state.dialogApiData && this.state.dialogApiData.responseBody && this.state.dialogApiData.responseBody.id
    const searchFiltersQuery = CRMHelper.constructSearchFiltersQuery(this.state.searchFilters, this.state.filterOptions, this.state.showInternal, this.restrictViewCrmFilters.assignee)
    const queryParams = { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId), query: this.state.searchText || '', pb: 'fieldDef,fieldDefBulkRouteCrmContact', limit: 1, _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.getDateInterval(this.state.searchFilters, this.state.timezone), _aggTermsLimit: this.aggregationTermsLimit, ...searchFiltersQuery }
    const options = [
      { key: 'crmuser', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts', orgIdUserId], queryParams: { orgId: this.orgId, pb: 'fieldDef,fieldDefBulkRouteCrmContact' } },
      { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams }
    ]

    const fcns = [];
    for (const f of options) {
      fcns.push(function (callback) {
        ApiHelper.call(f, callback);
      })
    }

    async.parallel(fcns, async function (err, results) {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      const { fieldDef, _apiVersion, ...updatedResult } = results[0];
      const updatedItems = this.state.items.map(item => item.userId === results[0].userId ? updatedResult : item );
      this.setState({
        items: updatedItems,
        stats: results[1].stats,
        cards: (results[1] && Array.isArray(results[1].cards)) ? results[1].cards.map(c => ({...c, key: c.key || c.label.toLowerCase()})) : null,
        availableTabs: (results[1] && Array.isArray(results[1].tabs)) ? results[1].tabs.map(tab => ({
          label: tab.label,
          filter: tab.filter || '',
          count: tab.count,
          _sortKey: tab._sortKey,
          _sortOrder: tab._sortOrder,
          active: tab.active || false,
        })) : [],
        timezone: results[1]._datetimezone || Helper.getLocalTimezone(),
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
      })
    }.bind(this))
  }

  onCompleteAction(options) {
    const reqBody = options && options.apiInvokeData && options.apiInvokeData.reqBody
    const isClickToCall = reqBody && reqBody._isClickToCall
    if (isClickToCall) {
      this.setState({
        modalOpen: false,
        dialogApiData: options.apiInvokeData,
        showToast: true,
        isErrorToast: false,
        toastMsg: 'Call initiated'
      })
    } else if(this.formDefinition && this.formDefinition.loadingMode === ApiHelper.LOADING_MODE.INSTANT_LOAD) {
      this.setState({ modalOpen: false, dialogApiData: options.apiInvokeData, loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD })
      this.fetchItem()
    } else {
      this.setState({ modalOpen: false, items: [], dialogApiData: options.apiInvokeData })
      this.fetchItems()
    }
  }

  shouldShowExportButton() {
    return AppHelper.isSettingEnabled(this.orgId, 'CRM_DASHBOARD_EXPORT_BUTTON')
  }

  shouldExcludeSubOrgQuickFilters() {
    return !!(this.subOrgId || this.teamsUnifiedView)
  }

  getVisibleCustomFilters() {
    return CRMHelper.getCustomFilters(this.orgId, this.pageKey, {
      excludeSubOrgReferencing: this.shouldExcludeSubOrgQuickFilters(),
    }) || []
  }

  initializeCRMContacts() {
    Helper.loadAttrOptions(this.fieldDef, this.crmContactAttrs, 'tags')
    const tagsField = Helper.getField(this.fieldDef, 'tags')
    if(tagsField && tagsField.options) {
      tagsField.options = tagsField.options.sort((a, b) => a.label.localeCompare(b.label));
    }
    if (this.accountFieldDef && this.crmContactAttrs) {
      CRMHelper.mergeAttrOptionsIntoField(this.accountFieldDef, this.crmContactAttrs, 'tags', 'account.tags')
      const accountTagsField = Helper.getField(this.accountFieldDef, 'account.tags')
      if (accountTagsField && accountTagsField.options) {
        accountTagsField.options = accountTagsField.options.sort((a, b) => a.label.localeCompare(b.label))
      }
    }
    UiHelper.populateOptions(this.fieldDef, {items: StaffHelper.uniqueStaffByUserId(this.staffUsers)}, 'assignee')
    UiHelper.populateOptions(this.fieldDef, {items: this.crmAccountNames}, 'accounts')
    UiHelper.populateOptions(this.fieldDef, {items: this.crmAccountNames}, 'primaryAccountId')
    UiHelper.populateOptions(this.fieldDef, {items: this.subOrgs}, 'subOrgId')
    if ((this.subOrgId && !this.teamsUnifiedView) || !this.teamsEnabled) {
      this.fieldDef.steps[0].fields = this.fieldDef.steps[0].fields.filter(f => f.key !== 'subOrgId')
    }
    applyTeamsUnifiedAssignedTeamRequired(this.fieldDef, this.teamsUnifiedView, this.teamsEnabled)
    if(!AppHelper.isABMEnabled(this.orgId)) {
      this.fieldDef.steps[0].fields = this.fieldDef.steps[0].fields.filter((field)=>!['accounts','primaryAccountId'].includes(field.key))
    }
    this.contactPreviewFieldDef = null
    const contactPreviewTemplate = AppHelper.getSetting(this.orgId, 'CRM_CONTACT_PREVIEW_TEMPLATE')
    if (contactPreviewTemplate && this.crmContactsResult && this.crmContactsResult.fieldDef) {
      this.contactPreviewFieldDef = JSON.parse(JSON.stringify(this.crmContactsResult.fieldDef))
      CRMHelper.appendContactInfoDisplayFields(this.contactPreviewFieldDef, {
        isLeadRoutingEnabled: this.isLeadRoutingEnabled,
        crmContactsStats: this.crmContactsStats,
      })
    }
  }

  onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    if (!fetchNext) {
      this.crmContactsResult = this.getResult(results, 'crmcontacts')
      this.fieldDef = this.formDefinition = this.crmContactsResult.fieldDef
      this.accountFieldDef = AppHelper.isABMEnabled(this.orgId)
        ? CdpHelper.enrichAccountFieldDefRangeOptions(this.crmContactsResult.accountFieldDef, this.crmContactsResult.stats)
        : null
      this.crmContactsStats = this.crmContactsResult.stats
      this.crmContactAttrs = this.getResult(results, 'crmcontactattrs')
      this.staffUsers = this.getResult(results, 'usersORG').items
      this.currentStaffUser = this.getResult(results, 'usersME')
      this.crmSequences = CdpHelper.filterOutDeletedCampaigns(this.getResult(results, 'crmsequences').items).sort((a, b) => b.createdTs - a.createdTs)
      this.crmInboxes = this.getResult(results, 'crminboxes').items
      this.crmEmailTemplatesResult = this.getResult(results, 'crmemailtemplates')
      this.crmEmailTemplates = this.crmEmailTemplatesResult.items
      this.crmEmailTemplateFieldDef = this.crmEmailTemplatesResult.fieldDef
      this.crmUserSettingsResult = this.getResult(results, 'crmusersettings')
      this.crmUserSettings = this.crmUserSettingsResult.items
      this.crmBulkImportJobs = this.getResult(results, 'crmbulkimportjobs').items
      this.crmAccountNames = this.getResult(results, 'crmaccountnames')
      this.filterSegments = (this.getResult(results, 'csegments').items || []).filter(s => s.type === 'FILTER')
      this.subOrgsResult = this.getResult(results, 'suborgs')
      this.subOrgs = this.teamsUnifiedView
        ? AppHelper.getAccessibleTeams(this.orgId)
        : (this.subOrgsResult ? this.subOrgsResult.items : [])
      this.bulkRouteCrmContactFieldDef = this.crmContactsResult.fieldDefBulkRouteCrmContact
      const showTenantNameInHeader = AppHelper.isSettingEnabled(this.orgId, 'TENANT_NAME_IN_HEADER')
      if (showTenantNameInHeader && !Controller.get().userMgr().isProductSU()) {
        this.pageTitle = UiHelper.getOrgTitle() || this.pageTitle
      }

      this.initializeCRMContacts()

      this.apiData = {
        orgId: this.orgId,
        creatorId: `${this.subOrgId || this.orgId}-${this.currentStaffUser.id}`,
      }
      const showExportButton = this.shouldShowExportButton()
      if (showExportButton && !this.isMobileView) {
        const isHeaderActionsPresent = this.headerActions.some(action => action.label === 'Export')
        if(!isHeaderActionsPresent) {
          this.headerActions.splice(this.headerActions.length - 1, 0, {
            label: 'Export',
            tooltip: 'Export',
            icon: 'download',
            type: 'icon-label',
            onClick: () => {
              const fieldDef = getExportFieldDef(this.orgId)
              fieldDef.title = Helper.getString('exportContacts')
              this.openModalForAdd(fieldDef)
            }
          })
        }
      }
    } else {
      this.crmContactsResult = results[0]
      this.fieldDef = this.formDefinition = this.crmContactsResult.fieldDef
      this.accountFieldDef = AppHelper.isABMEnabled(this.orgId)
        ? CdpHelper.enrichAccountFieldDefRangeOptions(this.crmContactsResult.accountFieldDef, this.crmContactsResult.stats)
        : null
      this.initializeCRMContacts()
    }
    this.transform(this.crmContactsResult);
    this.handleNextpage(this.crmContactsResult)

    const filterFormDefConf = CRMHelper.buildCrmContactFilterFormDefConf({fieldDef: this.fieldDef, accountFieldDef: this.accountFieldDef, crmSequences: this.crmSequences, crmInboxes: this.crmInboxes, crmBulkImportJobs: this.crmBulkImportJobs, crmContactsStats: this.crmContactsStats, orgId: this.orgId, currentUser: this.currentUser, subOrgs: this.subOrgs, staffUsers: this.staffUsers, isLeadRoutingEnabled: this.isLeadRoutingEnabled})
    const tabs = (this.crmContactsResult && Array.isArray(this.crmContactsResult.tabs)) ? this.crmContactsResult.tabs : []
    const activeTabFromUrl = new URLSearchParams(window.location.search).get('_activeTab')
    const selectedTab = tabs.find(tab => tab.label === activeTabFromUrl) || tabs[0]
    const getFilterOptionsResult = CRMHelper.getFilterOptions(
      this.fieldDef,
      filterFormDefConf,
      window.location.href,
      this.accountFieldDef
    )

    const { searchText, searchFilters, showInternal } = getFilterOptionsResult
    if (selectedTab && tabs.length > 0) {
      searchFilters._activeTab = selectedTab.label
    }
    const normalizeSingleValue = value => Array.isArray(value) ? value[0] : value
    const preservedUserSortKey = this.state.userSortKey || null
    const preservedUserSortOrder = this.state.userSortOrder || null
    const restoredSortKey = normalizeSingleValue(searchFilters._sortKey) || (selectedTab && selectedTab._sortKey)
    const restoredSortOrder = normalizeSingleValue(searchFilters._sortOrder) || preservedUserSortOrder || (selectedTab && selectedTab._sortOrder) || 'desc'
    const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
    const effectiveSortKey = preservedUserSortKey || (selectedTab && selectedTab._sortKey) || null
    const isUniboxBtnEnabled = AppHelper.isCRMUniboxEnabled(this.orgId) && !!effectiveSortKey && effectiveSortKey === uniboxSortKey
    let filterOptions = getFilterOptionsResult.filterOptions
    if(filterOptions) {
      filterOptions = CRMHelper.processFilterOptions(filterOptions, this.orgId)
    }

    if (this.isLeadRoutingEnabled && this.bulkRouteCrmContactFieldDef) {
      const routingMaxStaffLoad = AppHelper.getSetting(this.orgId, 'LEAD_ROUTING_MAX_STAFF_LOAD')
      const parsedRoutingMaxStaffLoad = parseInt(routingMaxStaffLoad, 10)
      const maxStaffLoadField = Helper.getField(this.bulkRouteCrmContactFieldDef, 'maxStaffLoad')
      if (maxStaffLoadField) {
        maxStaffLoadField.defaultValue = Number.isInteger(parsedRoutingMaxStaffLoad) ? String(parsedRoutingMaxStaffLoad) : '10'
      }

      const allowedSubOrgIdsField = Helper.getField(this.bulkRouteCrmContactFieldDef, 'allowedSubOrgIds')
      if (allowedSubOrgIdsField && Array.isArray(this.subOrgs) && this.subOrgs.length > 0) {
        allowedSubOrgIdsField.options = this.subOrgs.map((subOrg) => ({ key: subOrg.id, label: subOrg.title }))
      }
    }
    const p = new Promise((resolve, reject) => {
      try {
        this.setState({
          items: fetchNext ? this.state.items.concat(this.crmContactsResult.items) : this.crmContactsResult.items,
          stats: this.crmContactsResult.stats,
          cards: (this.crmContactsResult && Array.isArray(this.crmContactsResult.cards)) ? this.crmContactsResult.cards.map(c => ({...c, key: c.key || c.label.toLowerCase()})) : null,
          availableTabs: (this.crmContactsResult && Array.isArray(this.crmContactsResult.tabs)) ? this.crmContactsResult.tabs.map(tab => ({
            label: tab.label,
            filter: tab.filter || '',
            count: tab.count,
            _sortKey: tab._sortKey,
            _sortOrder: tab._sortOrder,
            active: tab.active || false,
          })) : [],
          activeTabLabel: selectedTab ? selectedTab.label : null,
          sortKey: restoredSortKey,
          sortOrder: restoredSortOrder,
          userSortKey: preservedUserSortKey,
          userSortOrder: preservedUserSortOrder,
          timezone: this.crmContactsResult._datetimezone || Helper.getLocalTimezone(),
          filterOptions,
          searchText,
          searchFilters,
          showInternal: showInternal,
          isUniboxBtnEnabled: isUniboxBtnEnabled
        }, async () => {
          if (!fetchNext && (this.state.searchText || Object.keys(this.state.searchFilters).length > 0)) {
            resolve(this.onSearch(this.state.searchText, this.state.searchFilters, this.state.filterOptions))
          }
          resolve()
        })
      } catch (err) {
        reject(err)
      }
    })
    return p
  }

  transform(result) {
    result.items.forEach(i => {
      const displayLabels = [];
      if (i.cognitoVerified) displayLabels.push('OTP VERIFIED');
      if (i.createdOnFormSubmission) displayLabels.push('CREATED BY FORM');
      if (i.createdByImport) displayLabels.push('CREATED BY IMPORT');
      if (displayLabels.length <= 0 && (i.emailAdminVerified || i.phoneAdminVerified)) {
        displayLabels.push('CREATED ON CONSOLE');
      }
      if (i.source) displayLabels.push(`SOURCE: ${i.source}`)
      if (displayLabels.length > 0) {
        i.displayLabels = displayLabels;
      }
    });
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  handleTabChange = (tab, chartType) => {
    this.setState({
      selectedTabData: {
        ...this.state.selectedTabData,
        [chartType]: tab
      }
    })
  }
  closeEntityDialog = (entityId = this.state.entityId) => {
    const dialogApiData = {
      responseBody: { id: entityId }
    }

    this.setState({
      isEntityDialogOpen: false,
      isEntityDialogLoading: false,
      dialogApiData,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD
    }, () => this.fetchItem())
  }

  tabbedChart1Actions = () => {
    const dateInterval = CRMHelper.getLabelFromDateId(this.defaultDateInteval.id) || this.defaultDateInteval.id
    return(<span className={css(Styles.chartLabel)}>{dateInterval}</span>)
  }

  handleCardClick = (card) =>{
    let searchFilters = this.state.searchFilters || {}
    let filterOptions = this.state.filterOptions || []
    let searchText = this.state.searchText || ''
    let showInternal = this.state.showInternal || false

    if (Array.isArray(this.state.cards) && this.state.cards.length > 0) {
      const clickedCard = this.state.cards.find(c => c.key === card)
      const filterFormDefConf = CRMHelper.buildCrmContactFilterFormDefConf({fieldDef: this.fieldDef, accountFieldDef: this.accountFieldDef, crmSequences: this.crmSequences, crmInboxes: this.crmInboxes, crmBulkImportJobs: this.crmBulkImportJobs, crmContactsStats: this.crmContactsStats, orgId: this.orgId, currentUser: this.currentUser, subOrgs: this.subOrgs, isLeadRoutingEnabled: this.isLeadRoutingEnabled})
      const getFilterOptionsResponse = CRMHelper.getFilterOptions(this.fieldDef, filterFormDefConf, `https://filter.slixta.com?${clickedCard.filter}`, this.accountFieldDef)
      filterOptions = getFilterOptionsResponse.filterOptions
      searchText = getFilterOptionsResponse.searchText
      searchFilters = Object.assign({}, searchFilters, getFilterOptionsResponse.searchFilters || {})
      showInternal = getFilterOptionsResponse.showInternal
    } else {
      let filterSelectedOperator = 'equals'
      let filter
      if(['leads', 'customers'].includes(card)) {
        filter = 'state'
        let stateSearchFilters = {}
        if(card === 'leads') {
          stateSearchFilters = {
            'state!': ['PROSPECT','UNQUALIFIED']
          }
          filterSelectedOperator = 'not equals'
        } else if(card === 'customers') {
          stateSearchFilters = {
            state: ['CUSTOMER']
          }
          filterSelectedOperator = 'equals'
        }

        if(filter in searchFilters) {
          delete searchFilters.state
        }
        searchFilters = {
          ...searchFilters,
          ...stateSearchFilters
        }
      } else if(card === 'linkedInRequested') {
        filter = 'linkedinConnectionStatus'
        const linkedInConnectionsSearchFilters = {
          linkedinConnectionStatus: ['requested']
        }
        if(filter in searchFilters) {
          delete searchFilters.linkedinConnectionStatus
        }
        searchFilters = {
          ...searchFilters,
          ...linkedInConnectionsSearchFilters
        }
      } else if(card === 'linkedInConnected') {
        filter = 'linkedinConnectionStatus'
        const linkedInConnectionsSearchFilters = {
          linkedinConnectionStatus: ['connected']
        }
        if(filter in searchFilters) {
          delete searchFilters.linkedinConnectionStatus
        }
        searchFilters = {
          ...searchFilters,
          ...linkedInConnectionsSearchFilters
        }
      }

      filterOptions = filterOptions.map((option)=>{
        if(option.key === filter) {
          return { ...option, selectedOperator: filterSelectedOperator };
        }
        return option
      })
    }
    this.onSearch(searchText, searchFilters, filterOptions || [])
  }

  isFilterApplied = (filter) =>{
    let filterEqual
    let filterNotEqual
    if(filter === 'state') {
      filterEqual = this.state.searchFilters.state
      filterNotEqual = this.state.searchFilters['state!']
    } else if(filter === 'linkedinConnectionStatus') {
      filterEqual = this.state.searchFilters.linkedinConnectionStatus
      filterNotEqual = this.state.searchFilters['linkedinConnectionStatus!']
    } else {
      try {
        const _url = new URL(`https://filter.slixta.com?${filter}`)
        let _isFilterApplied = false
        _url.searchParams.forEach((value, key) => {
          if(key) {
            const normalizedFilterKey = FilterHelper.getFilterBaseKey(key)
            const notOperatorFilterKey = normalizedFilterKey + '!'
            const allOperatorFilterKey = normalizedFilterKey + '~'
            const containsOperatorFilterKey = normalizedFilterKey + '*'
            const normalizedAppliedFilter = this.state.searchFilters[normalizedFilterKey]
            const notOperatorAppliedFilter = this.state.searchFilters[notOperatorFilterKey]
            const allOperatorAppliedFilter = this.state.searchFilters[allOperatorFilterKey]
            const containsOperatorAppliedFilter = this.state.searchFilters[containsOperatorFilterKey]

            if (normalizedAppliedFilter && (!Array.isArray(normalizedAppliedFilter) || normalizedAppliedFilter.length > 0)) { _isFilterApplied = true }
            if (notOperatorAppliedFilter && (!Array.isArray(notOperatorAppliedFilter) || notOperatorAppliedFilter.length > 0)) { _isFilterApplied = true }
            if (allOperatorAppliedFilter && (!Array.isArray(allOperatorAppliedFilter) || allOperatorAppliedFilter.length > 0)) { _isFilterApplied = true }
            if (containsOperatorAppliedFilter && (!Array.isArray(containsOperatorAppliedFilter) || containsOperatorAppliedFilter.length > 0)) { _isFilterApplied = true }
          }
        })
        if (_isFilterApplied) { return true }
      } catch (err) {
        console.log(err)
      }
    }
    if ((filterEqual && Array.isArray(filterEqual) && filterEqual.length > 0) || (filterNotEqual && Array.isArray(filterNotEqual) && filterNotEqual.length > 0)) {
      return true
    }
    return false
  }

  chartExpandedTableFilterClickHandler({selectedTabKey, key, label}) {
    let value = label
    if((selectedTabKey === 'suborgs' || selectedTabKey === 'assignees') && key) {
      value = key
    }
    // Prefer stable band/option keys (e.g. employeeCount "1 to 10") over display labels
    if (key && CRMHelper.isAccountDashboardChartTabKey(selectedTabKey)) {
      value = key
    }

    this.chartExpandedTableFilterHandler(selectedTabKey, value)
  }

  chartExpandedTableRowActons({selectedTabKey, key, label, header}) {
    const actions = []
    let value = label
    if((selectedTabKey === 'suborgs' || selectedTabKey === 'assignees') && key) {
      value = key
    }
    if (key && CRMHelper.isAccountDashboardChartTabKey(selectedTabKey)) {
      value = key
    }

    actions.push(
      <Tooltip title={'Apply Filter'} classes={{ popper: css(Styles.tooltip) }}>
        <IconButton
          disableRipple
          className={css(AppStyles.entityTableLinkIcon)}
          onClick={()=>this.chartExpandedTableFilterHandler(selectedTabKey, value)}
        >
          <i className='material-icons-outlined'>filter_alt</i>
        </IconButton>
      </Tooltip>)

    actions.push(
      <Tooltip title={`Copy ${header}`} classes={{ popper: css(Styles.tooltip) }}>
        <IconButton
          disableRipple
          className={css(AppStyles.entityTableLinkIcon)}
          onClick={() => {
            Helper.copyToClipboard(label)
            if(!Helper.isAndroidDevice()) {
              this.setState({
                showToast: true,
                isErrorToast: false,
                toastMsg: 'Copied to clipboard'
              })
            }
          }}
        >
          <FileCopyOutlinedIcon style={{fontSize: 22}}/>
        </IconButton>
      </Tooltip>)

    if(CRMHelper.isValidURL(label)) {
      actions.push(
        <Tooltip title={'Open'} classes={{ popper: css(Styles.tooltip) }}>
          <IconButton
            disableRipple
            className={css(AppStyles.entityTableLinkIcon)}
            onClick={() => window.open(label, '_blank')}
          >
            <OpenInNewIcon style={{fontSize: 22}}/>
          </IconButton>
        </Tooltip>)
    }

    return actions
  }

  chartExpandedTableFilterHandler(key, cell) {
    let searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters)) || {}
    const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions)) || []
    let customSearchFilters = {}
    if(key === 'states') {
      if(cell) {
        customSearchFilters = {
          state: [UiHelper.renameCRMContactLeadStatus(this.orgId, cell, true)]
        }
      }
      delete searchFilters.state
      delete searchFilters['state!']
    } else if(key === 'tags') {
      if(cell) {
        customSearchFilters = {
          tags: [cell]
        }
      }
      delete searchFilters.tags
      delete searchFilters['tags!']
    } else if(key === 'sources') {
      if(cell) {
        customSearchFilters = {
          source: [cell]
        }
      }
      delete searchFilters.source
      delete searchFilters['source!']
    } else if(key === 'utm_campaigns') {
      if(cell) {
        customSearchFilters = {
          utmCampaign: [cell]
        }
      }
      delete searchFilters.utmCampaign
      delete searchFilters['utmCampaign!']
      delete searchFilters['utmCampaign*']
    } else if(key === 'utm_contents') {
      if(cell) {
        customSearchFilters = {
          utmContent: [cell]
        }
      }
      delete searchFilters.utmContent
      delete searchFilters['utmContent!']
      delete searchFilters['utmContent*']
    } else if(key === 'suborgs') {
      if(cell) {
        customSearchFilters = {
          subOrgId: [cell]
        }
      }
      delete searchFilters.subOrgId
      delete searchFilters['subOrgId!']
    } else if(key === 'assignees') {
      if(cell) {
        customSearchFilters = {
          assignee: [cell]
        }
      }
      delete searchFilters.assignee
      delete searchFilters['assignee!']
    } else if(key === 'jobTitle') {
      if(cell) {
        customSearchFilters = {
          jobTitle: [cell]
        }
      }
      delete searchFilters.jobTitle
      delete searchFilters['jobTitle!']
      delete searchFilters['jobTitle*']
    } else if (key && CRMHelper.isAccountDashboardChartFilterKey(key)) {
      searchFilters = CRMHelper.applyAccountChartFilter(searchFilters, key, cell, {
        fieldDef: this.fieldDef,
        accountFieldDef: this.crmContactsResult && this.crmContactsResult.accountFieldDef,
      })
      customSearchFilters = {}
    }

    searchFilters = {
      ...searchFilters,
      ...customSearchFilters
    }
    this.onSearch(this.state.searchText || '', searchFilters, filterOptions || [])

  }

  onCustomFilterSelect(value) {
    const basePath = `${window.location.origin}${this.baseRoute()}/crm-contacts`
    const params = new URLSearchParams(value)
    if (this.state.activeTabLabel) {
      params.set('_activeTab', this.state.activeTabLabel)
    }
    const url = `${basePath}?${params.toString()}`
    window.history.replaceState({}, '', url);

    this.setState({
      isCustomFiltersDialogOpen: false
    })
    let searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters)) || {}
    const preservedSearchFilters = ['_sortKey', '_sortOrder', '_activeTab']
    searchFilters = Object.fromEntries(
      Object.entries(searchFilters).filter(([key]) => preservedSearchFilters.includes(key))
    )
    let filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions)) || []
    let searchText = ''
    const filterFormDefConf = CRMHelper.buildCrmContactFilterFormDefConf({fieldDef: this.fieldDef, accountFieldDef: this.accountFieldDef, crmSequences: this.crmSequences, crmInboxes: this.crmInboxes, crmBulkImportJobs: this.crmBulkImportJobs, crmContactsStats: this.crmContactsStats, orgId: this.orgId, currentUser: this.currentUser, subOrgs: this.subOrgs, isLeadRoutingEnabled: this.isLeadRoutingEnabled})
    const result = CRMHelper.getFilterOptions(this.fieldDef, filterFormDefConf, undefined, this.accountFieldDef)
    if(result) {
      searchText = result.searchText
      filterOptions = result.filterOptions
      searchFilters = result.searchFilters ? {...searchFilters, ...result.searchFilters} : searchFilters
    }
    this.onSearch(searchText, searchFilters, filterOptions)
  }

  onAppliedFilterRemoved(key) {
    if(key === '_sortKey') {
      this.setState({
        isUniboxBtnEnabled: false
      })
    }
  }

  compactStatsTabClick(selectedIndex) {
    this.setState({
      compactStatsTabSelected: selectedIndex
    })
  }

  renderAboveTable() {
    const showStats = (this.state.stats && this.state.stats.states && this.state.stats.tags)
    const numContacts = this.state.stats ? (this.state.stats.count || 0) : 0
    const numOutreaches = this.state.stats && this.state.stats.tags ? (this.state.stats.tags.buckets.find(b => b.key === 'SEQSENT') || {}).doc_count || 0 : 0
    const numPropsects = this.state.stats && this.state.stats.states ? (this.state.stats.states.buckets.find(b => b.key === 'PROSPECT') || {}).doc_count || 0 : 0
    const numCustomers = this.state.stats && this.state.stats.states ? (this.state.stats.states.buckets.find(b => b.key === 'CUSTOMER') || {}).doc_count || 0 : 0
    const numUnqualified = this.state.stats && this.state.stats.states ? (this.state.stats.states.buckets.find(b => b.key === 'UNQUALIFIED') || {}).doc_count || 0 : 0
    const numSubscriptions = this.state.stats && this.state.stats.subscriptions ? this.state.stats.subscriptions.buckets.reduce((p, c) => p + c.doc_count, 0) : 0
    const numLeads = numContacts - (numPropsects + numUnqualified)
    const numRequestedLinkedinContacts = this.state.stats && this.state.stats.linkedin_connection_status ? (this.state.stats.linkedin_connection_status.buckets.find(b => b.key === 'requested') || {}).doc_count || 0 : 0
    const numConnectedLinkedinContacts = this.state.stats && this.state.stats.linkedin_connection_status ? (this.state.stats.linkedin_connection_status.buckets.find(b => b.key === 'connected') || {}).doc_count || 0 : 0
    const canChangeSortKey = this.isSortKeyChangeable()
    const canChangeSortOrder = this.isSortOrderChangeable()
    const chartTabsData = {
      tabbedChart1: [
        {
          chart: 'leads',
          title: 'Leads',
          key: 'leads_per_day',
          label: 'Leads',
          type: 'lineChart'
        },
        {
          chart: 'outreaches',
          title: 'Outreaches',
          key: 'outreaches_per_day',
          label: 'Outreaches',
          type: 'lineChart'
        },
        {
          chart: 'contacts',
          title: 'Contacts',
          key: 'users_per_day',
          label: 'Contacts',
          type: 'lineChart'
        },
      ],
      tabbedChart2: [
        {
          chart: 'status',
          title: 'Status',
          key: 'states',
          label: 'Status',
          type: 'pieChart',
          enableExpansion: true,
          headers: ['Status', 'Count'],
          showPercent: true,
          enableFilter: true,
          tableRowActions: this.chartExpandedTableRowActons.bind(this),
          filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
        },
        {
          chart: 'tags',
          title: 'Tags',
          key: 'tags',
          label: 'Contacts',
          type: 'barChart',
          enableExpansion: true,
          headers: ['Tag', 'Count'],
          searchColumns: ['Tag'],
          searchPlaceholder: 'Search by Tag',
          showPercent: true,
          enableFilter: true,
          expansionGroups: CRMHelper.getChartExpansionGroups(this.orgId, 'CRM_CONTACTS_TAG_GROUPS'),
          tableRowActions: this.chartExpandedTableRowActons.bind(this),
          filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
        },
        {
          chart: 'source',
          title: 'Source',
          key: 'sources',
          label: 'Source',
          type: 'pieChart',
          enableExpansion: true,
          headers: ['Source', 'Count'],
          showPercent: true,
          enableFilter: true,
          tableRowActions: this.chartExpandedTableRowActons.bind(this),
          filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
        },
      ]
    }

    const exportFilteredAction = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_EXPORT_FILTERED') && Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') &&
      !this.isMobileView ? [{
        label: 'Export Filtered',
        buttonStyle: Styles.actionButton,
        onClick: () => {
          this.handleExportFilteredClick()
        }
      }] : []
    if(AppHelper.isTeamsEnabled(this.orgId) && AppHelper.isSettingEnabled(this.orgId, 'CRM_DASHBOARD_TEAMS_CHART') && (!this.subOrgId || this.teamsUnifiedView)) {
      const teamsChart = {
        chart: 'teams',
        title: 'Teams',
        key: 'suborgs',
        label: 'Contacts',
        type: 'pieChart',
        enableExpansion: true,
        headers: ['Team', 'Count'],
        showPercent: true,
        enableFilter: true,
        tableRowActions: this.chartExpandedTableRowActons.bind(this),
        filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
      }
      chartTabsData.tabbedChart2.unshift(teamsChart)
    }

    if(AppHelper.isSettingEnabled(this.orgId, 'CRM_DASHBOARD_ASSIGNEE_CHART')) {
      const assigneesChart = {
        chart: 'assignees',
        title: 'Assignees',
        key: 'assignees',
        label: 'Contacts',
        type: 'pieChart',
        enableExpansion: true,
        headers: ['Assignee', 'Count'],
        showPercent: true,
        enableFilter: true,
        tableRowActions: this.chartExpandedTableRowActons.bind(this),
        filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
      }
      if(chartTabsData.tabbedChart2[0] && chartTabsData.tabbedChart2[0].chart === 'teams') {
        chartTabsData.tabbedChart2.splice(1, 0, assigneesChart)
      } else {
        chartTabsData.tabbedChart2.push(assigneesChart)
      }
    }

    if(AppHelper.isCrmDashboardUtmCampaignsChartEnabled(this.orgId)) {
      const utmCampaignsChart = {
        chart: 'campaign',
        title: 'Campaign',
        key: 'utm_campaigns',
        label: 'Campaign',
        type: 'pieChart',
        enableExpansion: true,
        headers: ['Campaign', 'Count'],
        searchColumns: ['Campaign'],
        searchPlaceholder: 'Search by Campaign',
        showTotal: true,
        showPercent: true,
        enableFilter: true,
        tableRowActions: this.chartExpandedTableRowActons.bind(this),
        filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
      }
      chartTabsData.tabbedChart2.push(utmCampaignsChart)
    }

    if(AppHelper.isCrmDashboardUtmContentsChartEnabled(this.orgId)) {
      const utmContentsChart = {
        chart: 'content',
        title: 'Content',
        key: 'utm_contents',
        label: 'Content',
        type: 'pieChart',
        enableExpansion: true,
        headers: ['Content', 'Count'],
        searchColumns: ['Content'],
        searchPlaceholder: 'Search by Content',
        showTotal: true,
        showPercent: true,
        enableFilter: true,
        tableRowActions: this.chartExpandedTableRowActons.bind(this),
        filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this)
      }
      chartTabsData.tabbedChart2.push(utmContentsChart)
    }

    if (AppHelper.isABMEnabled(this.orgId)) {
      const jobTitleBuckets = this.state.stats && this.state.stats.jobTitle
        && Array.isArray(this.state.stats.jobTitle.buckets)
        ? this.state.stats.jobTitle.buckets.filter(b => b && b.key != null && b.key !== '')
        : null
      // Show when stats unknown yet, or when there is at least one non-empty title bucket
      if (!jobTitleBuckets || jobTitleBuckets.length > 0) {
        chartTabsData.tabbedChart2.push({
          chart: 'jobTitle',
          title: 'Job Titles',
          key: 'jobTitle',
          label: 'Contacts',
          type: 'barChart',
          enableExpansion: true,
          headers: ['Job Title', 'Count'],
          searchColumns: ['Job Title'],
          searchPlaceholder: 'Search by Job Title',
          showPercent: true,
          enableFilter: true,
          tableRowActions: this.chartExpandedTableRowActons.bind(this),
          filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this),
        })
      }
      const accountCharts = CRMHelper.buildAccountDashboardChartTabs({
        orgId: this.orgId,
        stats: this.state.stats,
        keyPrefix: 'account.',
        label: 'Contacts',
        tableRowActions: this.chartExpandedTableRowActons.bind(this),
        filterClickHandler: this.chartExpandedTableFilterClickHandler.bind(this),
      })
      chartTabsData.tabbedChart2 = chartTabsData.tabbedChart2.concat(accountCharts)
    }

    const xLabelsDifference = this.getXLabelsDifference(this.state.timezone || Helper.getLocalTimezone())
    let chartData1 = null
    if(chartTabsData.tabbedChart1) {
      const keyTabbedChart1 = chartTabsData.tabbedChart1[this.state.selectedTabData.tabbedChart1].key
      const labelTabbedChart1 = chartTabsData.tabbedChart1[this.state.selectedTabData.tabbedChart1].label
      const typeTabbedChart1 = chartTabsData.tabbedChart1[this.state.selectedTabData.tabbedChart1].type
      const createdTs = this.state.searchFilters.createdTs || this.defaultDateInteval
      chartData1 = CRMHelper.generateMultiChartData({stats: this.state.stats, key: keyTabbedChart1, label: labelTabbedChart1, type: typeTabbedChart1, timezone: this.state.timezone, date: createdTs, orgId: this.orgId})
    }
    let chartData2 = null
    if(chartTabsData.tabbedChart2 && chartTabsData.tabbedChart2.length > 0) {
      const tab2Index = Math.min(
        this.state.selectedTabData.tabbedChart2 || 0,
        chartTabsData.tabbedChart2.length - 1
      )
      const keyTabbedChart2 = chartTabsData.tabbedChart2[tab2Index].key
      const labelTabbedChart2 = chartTabsData.tabbedChart2[tab2Index].label
      const typeTabbedChart2 = chartTabsData.tabbedChart2[tab2Index].type
      const stats = JSON.parse(JSON.stringify(this.state.stats))
      if(keyTabbedChart2 === 'suborgs' && stats && stats[keyTabbedChart2] && Array.isArray(stats[keyTabbedChart2].buckets)) {
        const teamsBuckets =  stats[keyTabbedChart2].buckets
        const subOrgContacts = teamsBuckets.reduce((sum, team) => {
          return team.key ? sum + team.doc_count : sum
        }, 0)
        const unassignedCount = (numContacts > 0) ? numContacts - subOrgContacts : 0;
        if (unassignedCount > 0) {
          teamsBuckets.push({
            key: 'none',
            doc_count: unassignedCount,
          });
        }

        teamsBuckets.forEach((team)=>{
          if(team.key === 'none') {
            team.label = '[UNASSIGNED]'
          } else if(team.key && Array.isArray(this.subOrgs) && this.subOrgs.length > 0) {
            const subOrg = this.subOrgs.find(subOrg => subOrg.id === team.key)
            if(subOrg && subOrg.title) {
              team.label =  subOrg.title
            }
          }
        })
      }
      if(keyTabbedChart2 === 'assignees' && stats && stats[keyTabbedChart2] && Array.isArray(stats[keyTabbedChart2].buckets)) {
        const assigneeBuckets = stats[keyTabbedChart2].buckets
        const assignedContacts = assigneeBuckets.reduce((sum, assignee) => {
          return assignee.key ? sum + assignee.doc_count : sum
        }, 0)
        const unassignedCount = (numContacts > 0) ? numContacts - assignedContacts : 0
        if (unassignedCount > 0) {
          assigneeBuckets.push({
            key: 'none',
            doc_count: unassignedCount,
          })
        }

        const staffNameById = new Map()
        if(Array.isArray(this.staffUsers)) {
          this.staffUsers.forEach((staffUser) => {
            if(staffUser) {
              const name = Helper.formatName(staffUser)
              if(staffUser.userId) {
                staffNameById.set(staffUser.userId, name)
              }
              if(staffUser.id) {
                staffNameById.set(staffUser.id, name)
              }
            }
          })
        }
        const deletedUserName = '[Deleted User]'
        assigneeBuckets.forEach((assignee) => {
          if(assignee.key === 'none') {
            assignee.label = '[UNASSIGNED]'
          } else if(assignee.key) {
            const userId = CRMHelper.getUserIdFromEnityId(assignee.key)
            assignee.label = staffNameById.get(userId) || staffNameById.get(assignee.key) || deletedUserName
          }
        })
      }
      chartData2 = CRMHelper.generateMultiChartData({stats: stats, key: keyTabbedChart2, label: labelTabbedChart2, type: typeTabbedChart2, timezone: this.state.timezone, orgId: this.orgId})
    }

    let cardsData = []
    if (Array.isArray(this.state.cards) && this.state.cards.length > 0) {
      this.state.cards.forEach((card, i) => {
        cardsData.push({
          key: card.key,
          text: (card.key && card.key.startsWith('ltv')) ? Helper.formatLargeNumber(card.ltv || 0) : card.doc_count || 0,
          subText: card.label,
          cardIndex: i + 1,
          cardId: card.key,
          padding: 'small',
          handleCardClick: card.filter && card.doc_count > 0 && !this.isFilterApplied(card.filter) && this.handleCardClick.bind(this)
        })
      })
      const maxCardsPerRowCdpSettings = AppHelper.getSetting(this.orgId, 'CRM_CUSTOM_STAT_CARDS_MAX_PER_ROW')
      let maxCardsPerRow = 7
      if(!isNaN(maxCardsPerRowCdpSettings) && maxCardsPerRowCdpSettings !== '' && maxCardsPerRowCdpSettings > 0) {
        maxCardsPerRow = Number(maxCardsPerRowCdpSettings)
      }
      cardsData = CRMHelper.splitCardsIntoBalancedRows(cardsData, maxCardsPerRow)
    } else {
      const cardsFirstRow = []
      if(numContacts > 0) {
        cardsFirstRow.push({
          key: 'contacts',
          text: numContacts,
          subText: 'Contacts',
          cardIndex: 1,
          padding: 'small',
        })
      }
      if(numOutreaches > 0) {
        cardsFirstRow.push({
          key: 'outreaches',
          text: numOutreaches,
          subText: 'Outreaches',
          cardIndex: 2,
          padding: 'small',
        })
      }
      cardsFirstRow.push({
        key: 'leads',
        text: numLeads,
        subText: 'Leads',
        cardIndex: 3,
        padding: 'small',
        cardId:'leads',
        handleCardClick: !this.isFilterApplied('state') && this.handleCardClick.bind(this)
      })
      if(AppHelper.isCrmDashboardCustomersCardEnabled(this.orgId) && numCustomers > 0) {
        cardsFirstRow.push({
          key: 'customers',
          text: numCustomers,
          subText: 'Customers',
          cardIndex: 4,
          padding: 'small',
          cardId: 'customers',
          handleCardClick: !this.isFilterApplied('state') && this.handleCardClick.bind(this)
        })
      }
      if(numRequestedLinkedinContacts > 0) {
        cardsFirstRow.push({
          key: 'linkedInRequested',
          text: numRequestedLinkedinContacts,
          subText: 'LI Requests',
          cardIndex: 5,
          padding: 'small',
          cardId: 'linkedInRequested',
          handleCardClick: !this.isFilterApplied('linkedinConnectionStatus') && this.handleCardClick.bind(this)
        })
      }
      if(numConnectedLinkedinContacts > 0) {
        cardsFirstRow.push({
          key: 'linkedInConnected',
          text: numConnectedLinkedinContacts,
          subText: 'Connections',
          cardIndex: 7,
          padding: 'small',
          cardId: 'linkedInConnected',
          handleCardClick: !this.isFilterApplied('linkedinConnectionStatus') && this.handleCardClick.bind(this)
        })
      }
      cardsData.push(cardsFirstRow)
    }

    const isOnlySortFilterApplied = this.state.searchFilters && Object.keys(this.state.searchFilters).length === 1 && this.state.searchFilters.hasOwnProperty('_sortKey')
    const TAB_STATE_FILTER_KEYS = ['_activeTab', '_sortKey', '_sortOrder']
    const isTabStateFilter = key => TAB_STATE_FILTER_KEYS.includes(key)

    const visibleSearchFilters = Object.fromEntries(
      Object.entries(this.state.searchFilters || {}).filter(([key]) => !isTabStateFilter(key))
    )
    const hasSavableFilters = Object.keys(visibleSearchFilters).length > 0 || !!this.state.searchText
    const isCompactStatsEnabled = AppHelper.isCompactStatsCardsMobileEnabled(this.orgId)
    let uniBoxCount = 0
    if (this.state.stats) {
      const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
      if (uniboxSortKey === 'activeIntSentTs' && this.state.stats.unread_active_last_int_sent) {
        uniBoxCount = this.state.stats.unread_active_last_int_sent.doc_count
      } else if (uniboxSortKey === 'lastIntSentTs' && this.state.stats.unread_last_int_sent) {
        uniBoxCount = this.state.stats.unread_last_int_sent.doc_count
      }
    }
    return <>
      <div className={css(Styles.aboveTableContainer)}>
        {this.isMobileView && isCompactStatsEnabled && (<div className={css(Styles.compactStatsTabsContainer)}>
          <CustomToggleButton buttonData={
            [
              {
                buttonText: 'Stats',
                onClick: this.compactStatsTabClick.bind(this,0)
              },
              {
                buttonText: 'Charts',
                onClick: this.compactStatsTabClick.bind(this,1)
              },
              {
                buttonText: 'Trends',
                onClick: this.compactStatsTabClick.bind(this,2)
              }
            ]
          }
          toggleButtonSelected={this.state.compactStatsTabSelected}
          fullWidth={true}
          />
        </div>)}
        {((cardsData.flat().length > 4 && !this.isMobileView) && cardsData && cardsData.length > 0) && (<div className={css(Styles.numericStatItemRow)}>
          {cardsData.map((row)=>(<Grid container className={css(Styles.numericStatContainerRow)}>
            {row.map((card)=>(
              <StatCard
                xs={4}
                sm={1}
                key={card.key}
                text={card.text}
                subText={card.subText}
                cardIndex={card.cardIndex}
                padding={card.padding}
                cardId={card.cardId}
                handleCardClick={card.handleCardClick}
                containerStyle={Styles.statsCardContainer}
                cardStyle={Styles.statsCard}
              />))}
          </Grid>))}
        </div>)}
        {((cardsData.flat().length > 4 && this.isMobileView && (!isCompactStatsEnabled || this.state.compactStatsTabSelected === 0))) && cardsData && cardsData.length > 0 && (<div className={css(Styles.numericStatItemRow)}>
          {cardsData.map((row, index) => {
            const rowGroups = Array.from({ length: Math.ceil(row.length / 3) })
            return (
              <Grid key={index}>
                {rowGroups.map((_, groupIndex) => {
                  const groupItems = row.slice(groupIndex * 3, groupIndex * 3 + 3)
                  return (
                    <Grid
                      key={groupIndex}
                      container
                      className={css(Styles.numericStatContainerRow)}
                    >
                      {groupItems.map((card) => (
                        <StatCard
                          xs={12 / groupItems.length}
                          sm={12 / groupItems.length}
                          key={card.key}
                          text={card.text}
                          subText={card.subText}
                          cardIndex={card.cardIndex}
                          padding={card.padding}
                          cardId={card.cardId}
                          handleCardClick={card.handleCardClick}
                          containerStyle={Styles.statsCardContainer}
                          cardStyle={Styles.statsCard}
                        />
                      ))}
                    </Grid>
                  )
                })}
              </Grid>
            )
          })}
        </div>)}
        {showStats &&
        <div className={css(Styles.statContainer)}>
          {((cardsData.flat().length <= 4 && (!this.isMobileView || (this.isMobileView && (!isCompactStatsEnabled || this.state.compactStatsTabSelected === 0)))) && cardsData && cardsData.length > 0) && (<div className={css(Styles.numericStatItem)}>
            {cardsData.map((row)=>(<Grid container className={css(Styles.numericStatContainer)}>
              {row.map((card)=>(
                <StatCard
                  xs={12 / row.length}
                  sm={12}
                  key={card.key}
                  text={card.text}
                  subText={card.subText}
                  cardIndex={card.cardIndex}
                  padding={card.padding}
                  cardId={card.cardId}
                  handleCardClick={card.handleCardClick}
                  cardStyle={Styles.statsCardSmall}
                />))}
            </Grid>))}
          </div>)}
          {chartData2 && (!this.isMobileView || (this.isMobileView && (!isCompactStatsEnabled || this.state.compactStatsTabSelected === 1))) && (<div className={(cardsData.flat().length <= 4) ? css(Styles.barStatItem) : css(Styles.barStatItemRow)}>
            <TabChartCard chartType={'tabbedChart2'} tabsData={chartTabsData} xLabelsDifference={xLabelsDifference} selectedTabData={this.state.selectedTabData} handleTabChange={this.handleTabChange} chartData={chartData2} isMultiChart={true} percentTotal={numContacts}/>
          </div>)}
          {chartData1 && (!this.isMobileView || (this.isMobileView && (!isCompactStatsEnabled || this.state.compactStatsTabSelected === 2))) && (<div className={(cardsData.flat().length <= 4) ? css(Styles.pieStatItem) : css(Styles.pieStatItemRow)}>
            <TabChartCard chartType={'tabbedChart1'} tabsData={chartTabsData} xLabelsDifference={xLabelsDifference} selectedTabData={this.state.selectedTabData} handleTabChange={this.handleTabChange} chartData={chartData1} isMultiChart={true} chartActions={!this.state.searchFilters.createdTs && this.tabbedChart1Actions.bind(this)}/>
          </div>)}
        </div>
        }
        <SearchBar
          hint={this.isMobileView ? 'Search' : 'Type Name, Email or Phone'}
          onSearch={(searchText, searchFilters, filterOptions) => {
            const preserved = {}
            if (this.state.searchFilters._activeTab) {
              preserved._activeTab = this.state.searchFilters._activeTab
            }
            if (this.state.searchFilters._sortKey) {
              preserved._sortKey = this.state.searchFilters._sortKey
            }
            if (this.state.searchFilters._sortOrder) {
              preserved._sortOrder = this.state.searchFilters._sortOrder
            }
            this.onSearch(searchText, { ...preserved, ...searchFilters }, filterOptions)
          }}
          onList={this.onList.bind(this)}
          onFiltersBtnClick={this.onFiltersBtnClick.bind(this)}
          onCustomFiltersBtnClick={this.onCustomFiltersBtnClick.bind(this)}
          onAppliedFilterRemoved={this.onAppliedFilterRemoved.bind(this)}
          getUpdatedSearchFilters={CRMHelper.getUpdatedSearchFilters}
          getTransformedKey={CRMHelper.getTransformedKey}
          searchText={this.state.searchText}
          searchFilters={visibleSearchFilters}
          searchFilterActions={Controller.get().roleHelper().hasCurrentOrgRole('SUPERUSER') && !this.isMobileView ? [
            {
              label: 'Save Segment',
              buttonStyle: Styles.actionButton,
              onClick: () => {
                const searchFilters = JSON.parse(JSON.stringify(visibleSearchFilters))
                const searchFilterTimeZone = Array.isArray(searchFilters._datetimezone) ? searchFilters._datetimezone[0] : searchFilters._datetimezone
                delete searchFilters._datetimezone
                const timezone = searchFilterTimeZone || Helper.getLocalTimezone()
                Object.entries(searchFilters).forEach(([k, v]) => {
                  if (!v) { delete searchFilters[k] }
                })
                const filtersQs = FilterHelper.processFilterFormSubmission({filterFormData: searchFilters, filterQueryData: this.state.searchText || '', timezone})
                this.apiData = {
                  orgId: this.orgId,
                  type: 'FILTER',
                  state: 'LIVE',
                  filtersQs,
                  timeZone: timezone,
                }
                this.formDefinition = getSaveSegmentFieldDef(this.filterSegments)
                this.setState({
                  modalOpen: true
                });
              }
            },
            {
              label: 'Save Filter',
              buttonStyle: Styles.actionButton,
              onClick: () => {
                const searchFilters = JSON.parse(JSON.stringify(visibleSearchFilters || {}))
                const searchFilterTimeZone = Array.isArray(searchFilters._datetimezone) ? searchFilters._datetimezone[0] : searchFilters._datetimezone
                delete searchFilters._datetimezone
                const timezone = searchFilterTimeZone || Helper.getLocalTimezone()
                Object.entries(searchFilters).forEach(([k, v]) => {
                  if (!v) { delete searchFilters[k] }
                })
                const filtersQs = FilterHelper.processFilterFormSubmission({filterFormData: searchFilters, filterQueryData: this.state.searchText || '', timezone})

                const customFilters = CRMHelper.getCustomFilters(this.orgId,this.pageKey) || []
                this.apiData = {
                  orgId: this.orgId,
                  filtersQs
                }
                this.formDefinition = getSaveFilterFieldDef(customFilters)
                this.setState({
                  modalOpen: true
                });
              }
            },...exportFilteredAction
          ] : [...exportFilteredAction]}
          filterOptions={this.state.filterOptions}
          searchButtonLabel='Search'
          listButtonLabel={'Clear Filters'}
          isQuickFilterDisabled={true}
          isAppliedFiltersVisible={true}
          timezone={this.state.timezone}
          getLabelFromDateId={CRMHelper.getLabelFromDateId}
          autoRefresh={false}>
        </SearchBar>

        <div className={css(Styles.uniboxControlsContainer)}>
          {this.state.availableTabs && this.state.availableTabs.length > 0 ? (
            <>
              <div style={{ display: 'flex' }}>
                <TabsView
                  buttonData={this.state.availableTabs.map((tab, index) => {
                    let badgeCount = null;
                    if (tab.active || !!tab.filter) {
                      badgeCount = tab.count;
                      if (this.state.stats && tab.active) {
                        if (tab._sortKey === 'activeIntSentTs' && this.state.stats.unread_active_last_int_sent) {
                          badgeCount = this.state.stats.unread_active_last_int_sent.doc_count;
                        } else if (tab._sortKey === 'lastIntSentTs' && this.state.stats.unread_last_int_sent) {
                          badgeCount = this.state.stats.unread_last_int_sent.doc_count;
                        }
                      }
                    }
                    return {
                      buttonText: tab.label,
                      badgeContent: badgeCount || null,
                      badgeTone: tab.active ? 'activeInt' : 'primary',
                      onClick: () => this.onTabClick(tab.label),
                    };
                  })}
                  toggleButtonSelected={this.state.availableTabs.findIndex(tab => tab.label === this.state.activeTabLabel)}
                />
              </div>
            </>
          ) : (
            <>
              {AppHelper.isCRMUniboxEnabled(this.orgId) &&
              <>
                <CustomToggleButton buttonData={
                  [
                    {
                      buttonText: 'Latest Contacts',
                      onClick: this.onUniboxBtnClick.bind(this,false),
                    },
                    {
                      buttonText: 'Active Interactions',
                      badgeContent: uniBoxCount || null,
                      badgeTone: 'activeInt',
                      onClick: this.onUniboxBtnClick.bind(this,true),
                    }
                  ]
                }
                toggleButtonSelected={this.state.isUniboxBtnEnabled ? 1 : 0}
                />
                <div className={css(Styles.sortAndAutoRefreshWrapper)}>
                  <div className={css(Styles.sortButtonsGroupCompact)}>
                    <button
                      className={css(Styles.sortByButton, !canChangeSortKey && Styles.sortByButtonDisabled)}
                      onClick={this.openSortByDialog}
                      disabled={!canChangeSortKey}
                    >
                      {`Sorted By: ${this.getSortKeyLabel()}`}
                    </button>
                    <Tooltip title={this.state.sortOrder === 'asc' ? 'Sort Order: Ascending' : 'Sort Order: Descending'} placement='top'>
                      <IconButton
                        size='small'
                        onClick={this.toggleSortOrder}
                        disabled={!canChangeSortOrder}
                        className={css(Styles.sortOrderButton, !canChangeSortOrder && Styles.sortOrderButtonDisabled)}
                        style={{
                          transform: this.state.sortOrder === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)',
                          transition: 'transform 0.2s ease'
                        }}
                      >
                        <ArrowUpwardIcon fontSize='small' />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_AUTO_REFRESH') && this.state.isUniboxBtnEnabled && (
                    <div className={css(Styles.autoRefreshButtonGroup)}>
                      <FormControlLabel
                        className={css(Styles.autoRefreshLabel)}
                        classes={{ label: css(Styles.autoRefreshLabelText) }}
                        control={(
                          <Switch
                            color='primary'
                            checked={this.state.isAutoRefreshEnabled}
                            onChange={this.onAutoRefreshToggle}
                          />
                        )}
                        label='Auto Refresh'
                      />
                    </div>
                  )}
                </div>
              </>
              }
            </>
          )}
        </div>
        {this.state.activeTabLabel && (
          <div className={css(Styles.sortAndRefreshWrapper)}>
            <div className={css(Styles.sortButtonsGroup)}>
              <button
                className={css(Styles.sortByButton, !canChangeSortKey && Styles.sortByButtonDisabled)}
                onClick={this.openSortByDialog}
                disabled={!canChangeSortKey}
              >
                {`Sorted By: ${this.getSortKeyLabel()}`}
              </button>
              <Tooltip title={this.state.sortOrder === 'asc' ? 'Sort Order: Ascending' : 'Sort Order: Descending'} placement='top'>
                <IconButton
                  size='small'
                  onClick={this.toggleSortOrder}
                  disabled={!canChangeSortOrder}
                  className={css(Styles.sortOrderButton, !canChangeSortOrder && Styles.sortOrderButtonDisabled)}
                  style={{
                    transform: this.state.sortOrder === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)',
                    transition: 'transform 0.2s ease'
                  }}
                >
                  <ArrowUpwardIcon fontSize='small' />
                </IconButton>
              </Tooltip>
            </div>
            {AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_AUTO_REFRESH') &&
             this.getActiveTabConfig() &&
             this.getActiveTabConfig().active && (
              <div className={css(Styles.autoRefreshGroup)}>
                <FormControlLabel
                  className={css(Styles.autoRefreshLabel)}
                  classes={{ label: css(Styles.autoRefreshLabelText) }}
                  control={(
                    <Switch
                      color='primary'
                      checked={this.state.isAutoRefreshEnabled}
                      onChange={this.onAutoRefreshToggle}
                    />
                  )}
                  label='Auto Refresh'
                />
              </div>
            )}
          </div>
        )}
      </div>
      {this.isMobileView && <Fab
        aria-label='add'
        disableRipple
        onClick={() => this.openModalForAdd()}
        className={css(Styles.floatingActionButton)}>
        <AddIcon />
      </Fab>}
    </>
  }

  renderBelowTable() {
    return (
    <>
      {this.state.isEntityDialogOpen && this.renderEntityDialog()}
      {this.state.isCustomFiltersDialogOpen && this.renderCustomFiltersDialog()}
      {this.state.isSortByDialogOpen && this.renderSortByDialog()}
      {this.state.isContactsFinderDialogOpen && this.renderContactsFinderDialog()}
      {this.state.isContactsFinderImportOpen && this.renderContactsFinderImportDialog()}
    </>
    )
  }
  openContactsFinderDialog = () => {
    this.setState({ isContactsFinderDialogOpen: true })
  }

  renderContactsFinderDialog() {
    return (
      <PageDialog
        PageComponent={ContactsFinder}
        PageComponentProps={{
          orgId: this.orgId,
          onFindEmailImport: (items) => this.openContactsFinderImport(items),
          onLinkedinImport: (importCsv, count) => this.openContactsFinderProspect(importCsv, count),
        }}
        title='Find Contacts'
        fullWidth
        fullHeight
        isOpen={this.state.isContactsFinderDialogOpen}
        onClosed={() => this.setState({ isContactsFinderDialogOpen: false })}
      />
    )
  }

  openContactsFinderImport(items) {
    this.setState({
      isContactsFinderDialogOpen: false,
      isContactsFinderImportOpen: true,
      contactsFinderImportItems: items || [],
    })
  }

  openContactsFinderProspect(importCsv, count) {
    this.apiData = {
      orgId: this.orgId,
      creatorId: `${this.subOrgId || this.orgId}-${this.currentStaffUser.id}`,
      isProspect: true,
      prospectSource: 'csv',
      importCsv,
    }
    this.formDefinition = this.contactsFinderImportFormDef(count)
    this.setState({ isContactsFinderDialogOpen: false, modalOpen: true })
  }

  contactsFinderImportFormDef(count) {
    return {
      title: count == null ? 'Find Email & Import' : `Find Email & Import (${count} ${count === 1 ? 'Contact' : 'Contacts'})`,
      description: UiHelper.enrichCreditsModalDescription(),
      customStyles: {
        modalDescriptionStyles: Styles.enrichCreditsNotice,
        confirmMessageStyles: Styles.finderImportMessage,
      },
      confirmMessage: 'We will attempt to find emails for these contacts and import the results. Credits will be consumed only when an email is found.',
      formType: 'add',
      ctaButtonText: 'Continue',
      maxWidth: 'sm',
      steps: [{ fields: [] }],
    }
  }

  renderContactsFinderImportDialog() {
    const count = Array.isArray(this.state.contactsFinderImportItems) ? this.state.contactsFinderImportItems.length : 0
    return (
      <DynamicFormDialog
        formDefinition={this.contactsFinderImportFormDef(count)}
        isOpen={this.state.isContactsFinderImportOpen}
        onClosed={() => this.setState({ isContactsFinderImportOpen: false, contactsFinderImportItems: [] })}
        customSubmit={async ({ caller }) => {
          try {
            await startContactFinderImport({
              orgId: this.orgId,
              items: this.state.contactsFinderImportItems,
            })
            window.open(this.baseRoute() + '/jobscrm', '_self')
          } catch (err) {
            caller.setState({ inProcess: false, success: false, message: Helper.getErrorMsg(err) })
          }
        }}
      />
    )
  }

  renderEntityDialog() {
    const PageComponent = this.state.isEntityDialogLoading ? EntityDialogLoading : CrmContact
    return (
      <PageDialog
        PageComponent={PageComponent}
        PageComponentProps={this.state.entityDialogProps}
        title={this.state.entityDialogTitle}
        isOpen={this.state.isEntityDialogOpen}
        fullWidth={this.state.entityDialogFullWidth}
        fullHeight={this.state.entityDialogFullHeight}
        onClosed={() => this.closeEntityDialog()}
      />
    );
  }

  renderCustomFiltersDialog() {
    const customFilters = this.getVisibleCustomFilters()
    return (
      <PageDialog
        PageComponent={CRMHelper.CustomFilters}
        PageComponentProps={this.state.customFiltersDialogProps}
        title={'Quick Filters'}
        fullWidth={customFilters.length > 5}
        maxWidth='sm'
        fullWidthDialog={false}
        isOpen={this.state.isCustomFiltersDialogOpen}
        onClosed={() => {
          this.setState({ isCustomFiltersDialogOpen: false })
        }}
      />
    );
  }

  renderSortByDialog = () => {
    const sortOptions = this.buildSortOptionsFromFieldDef()
    return (
      <PageDialog
        PageComponent={SortByDialog}
        PageComponentProps={{
          searchFilters: this.state.searchFilters || {},
          formDefinition: this.state.sortByFormDefinition,
          sortOptions: sortOptions,
          onSortKeyChange: this.onSortKeyChange,
          onClose: this.closeSortByDialog,
          isSortKeyChangeable: this.isSortKeyChangeable()
        }}
        title='Sorted By'
        isOpen={this.state.isSortByDialogOpen && this.isSortKeyChangeable()}
        onClosed={() => this.closeSortByDialog()}
      />
    );
  }

  isSortKeyChangeable = () => {
    const hasCustomTabs = Array.isArray(this.state.availableTabs) && this.state.availableTabs.length > 0
    if (hasCustomTabs) {
      const activeTabConfig = this.getActiveTabConfig()
      if (!activeTabConfig) return true
      return activeTabConfig._sortKey === undefined || activeTabConfig._sortKey === null || activeTabConfig._sortKey === ''
    }
    if (AppHelper.isCRMUniboxEnabled(this.orgId)) {
      return !this.state.isUniboxBtnEnabled
    }
    return true
  }
  isSortOrderChangeable = () => {
    const hasCustomTabs = Array.isArray(this.state.availableTabs) && this.state.availableTabs.length > 0
    if (hasCustomTabs) {
      const activeTabConfig = this.getActiveTabConfig()
      if (!activeTabConfig) return true
      return !activeTabConfig._sortOrder
    }
    return true
  }
  shouldIncludeSortInUrl = () => {
    return !!this.state.userSortKey || !!this.state.userSortOrder
  }

  getFilteredSearchFiltersForUrl = (searchFilters) => {
    const filtered = { ...searchFilters }
    const activeTab = this.getActiveTabConfig()
    delete filtered._sortKey
    delete filtered._sortOrder
    if (this.state.userSortKey && (!activeTab || !activeTab._sortKey)) {
      filtered._sortKey = this.state.userSortKey
    }
    if (this.state.userSortOrder && (!activeTab || !activeTab._sortOrder)) {
      filtered._sortOrder = this.state.userSortOrder
    }
    if (this.state.activeTabLabel && !filtered._activeTab) {
      filtered._activeTab = this.state.activeTabLabel
    }
    return filtered
  }

  handleNextpage(result) {
    super.handleNextpage(result)
    const currentItemCount = this.state.items ? this.state.items.length : 0
    const newItemCount = result.items ? result.items.length : 0
    const totalAfterFetch = currentItemCount + newItemCount

    if (totalAfterFetch >= this.maxPaginationItems) {
      this.setState({
        nextPage: null,
        nextPageState: ApiHelper.State.READY
      })
      return
    }

    if (this.toFetchNext && this.toFetchNext.queryParams && result.nextPage) {
      this.toFetchNext.queryParams.limit = this.isFirstFetchNext ? 900 : 1000
    }

    this.isFirstFetchNext = false
  }

  onSearch = (searchText = '', searchFilters = {}, filterOptions = [], loadingMode, preserveStats = false) => {
    this.isFirstFetchNext = true
    Object.keys(searchFilters).forEach(k => {
      if (Array.isArray(searchFilters[k]) && searchFilters[k].length === 0) {
        delete searchFilters[k]
      } else if (!Array.isArray(searchFilters[k]) && searchFilters[k] === '') {
        delete searchFilters[k]
      }
    })
    const filteredSearchFiltersForUrl = this.getFilteredSearchFiltersForUrl(searchFilters)
    CRMHelper.updateWindowUrl(searchText, filteredSearchFiltersForUrl, this.state.timezone)

    if(filterOptions) {
      filterOptions = CRMHelper.processFilterOptions(filterOptions, this.orgId)
    }

    this.setState({
      fetchState: ApiHelper.State.LOADING,
      searchText: searchText,
      searchFilters: searchFilters,
      filterOptions: filterOptions,
      loadingMode: loadingMode || ApiHelper.LOADING_MODE.PAGE_LOAD,
    })
    const searchFiltersQuery = CRMHelper.constructSearchFiltersQuery(searchFilters, filterOptions, this.state.showInternal, this.restrictViewCrmFilters.assignee)
    const formattedSearchText = searchText.trim().replace(/^\+(\d+)/, '$1').replace(/:/g, '\\:')
    const hasUserSortKey = !!this.state.userSortKey
    const queryParams = { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId), query: formattedSearchText, pb: 'fieldDef,fieldDefBulkRouteCrmContact', includeCustomFields: 'true', limit: 100, _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.getDateInterval(searchFilters, this.state.timezone), _aggTermsLimit: this.aggregationTermsLimit,
      ...(hasUserSortKey
        ? {
          _sortKey: this.state.userSortKey,
          ...((this.state.userSortOrder || this.state.sortOrder)
            ? {
              _sortOrder:
                this.state.userSortOrder || this.state.sortOrder
            }
            : {})
        }
        : {}),
      ...(this.state.activeTabLabel && { _activeTab: this.state.activeTabLabel }), ...searchFiltersQuery,  }
    const options = { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams }
    this.toFetch[0] = options

    return ApiHelper.callAwait(options).then(result => {
      this.transform(result)
      if (this.state.isAutoRefreshEnabled) {
        this.setState({
          nextPage: null,
          nextPageState: ApiHelper.State.READY
        })
      } else {
        this.handleNextpage(result)
      }

      const stateUpdate = {
        items: (result && result.items) || [],
        ...(!preserveStats && {
          stats: result.stats,
          cards: (result && Array.isArray(result.cards)) ? result.cards.map(c => ({...c, key: c.key || c.label.toLowerCase()})) : null,
        }),
        timezone: result._datetimezone || Helper.getLocalTimezone(),
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
      }

      if (result && Array.isArray(result.tabs) && result.tabs.length > 0) {
        const processedTabs = result.tabs.map(tab => ({
          label: tab.label,
          filter: tab.filter || '',
          count: tab.count,
          _sortKey: tab._sortKey,
          _sortOrder: tab._sortOrder,
          active: tab.active || false,
        }))
        stateUpdate.availableTabs = processedTabs
        if (!this.state.activeTabLabel && processedTabs.length > 0) {
          stateUpdate.activeTabLabel = processedTabs[0].label
        }
      }

      this.setState(stateUpdate)
    }).catch(err => {
      console.log('Search Error:', err)
      if (this.state.availableTabs && this.state.availableTabs.length > 0) {
        const firstTabLabel = this.state.availableTabs[0].label
        if (this.state.activeTabLabel !== firstTabLabel) {
          this.setState({
            showToast: true,
            isErrorToast: true,
            toastMsg: 'Invalid tab. Switching to default tab.'
          })
          this.onTabClick(firstTabLabel)
        } else {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
          })
        }
      } else {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD
        })
      }
    })
  }
  onSortKeyChange = (sortKeyInput) => {
    const nextSortKey = (typeof sortKeyInput === 'string'
      ? sortKeyInput
      : (sortKeyInput && sortKeyInput.target && sortKeyInput.target.value)
    ) || 'createdTs'

    const nextSearchFilters = {
      ...(this.state.searchFilters || {}),
      _sortKey: nextSortKey
    }

    this.setState(
      { sortKey: nextSortKey, userSortKey: nextSortKey, searchFilters: nextSearchFilters },
      () => {
        this.onSearch(
          this.state.searchText || '',
          nextSearchFilters,
          this.state.filterOptions || [],
          ApiHelper.LOADING_MODE.TABLE_LOAD
        )
        this.closeSortByDialog()
      }
    )
  }
  onFiltersBtnClick = (searchText = '', searchFilters = {}, filterOptions = [], isFilterChanged = false, isSearchTextChanged = false) => {
    const preserved = {}
    const TAB_METADATA_KEYS = ['_activeTab', '_sortKey', '_sortOrder']
    TAB_METADATA_KEYS.forEach(key => {
      if (this.state.searchFilters && this.state.searchFilters[key]) {
        preserved[key] = this.state.searchFilters[key]
      }
    })
    this.setState({
      searchText: searchText,
      searchFilters: {...preserved, ...searchFilters},
      filterOptions: filterOptions,
    }, () => {
      const filtersFieldDef = CRMHelper.getFilterDialogFieldDef(filterOptions)
      UiHelper.removeHiddenCrmContactStates(Helper.getField(filtersFieldDef, 'state'), this.orgId)
      if (this.subOrgId && !this.teamsUnifiedView && filtersFieldDef) {
        ['assignee', 'routedAssignee'].forEach((key) => {
          const field = Helper.getField(filtersFieldDef, key)
          if (field && field.options) {
            field.options = CRMHelper.filterAssigneeOptionsByOrgAccess(field.options, this.staffUsers, this.subOrgId)
          }
        })
      }
      const normalizedSearchFilters = CRMHelper.getNormalizedSearchFilters(filterOptions, searchFilters)
      this.openModalForFilter(normalizedSearchFilters, filtersFieldDef);
    })
  }

  onCustomFiltersBtnClick = () => {
    this.setState({
      isCustomFiltersDialogOpen: true,
      customFiltersDialogProps: {
        pageTitle: 'Quick Filters',
        orgId: this.orgId,
        pageKey:this.pageKey,
        excludeSubOrgReferencingCustomFilters: this.shouldExcludeSubOrgQuickFilters(),
        onCustomFilterSelect: this.onCustomFilterSelect.bind(this),
        onCustomFilterDelete: (filter) => CRMHelper.handleCustomFilterDelete(this, filter),
        onCustomFilterRename: (filter, newLabel) => CRMHelper.handleCustomFilterRename(this, filter, newLabel),
      }
    })
  }

  handleExportFilteredClick = () => {
    const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
    const searchFilterTimeZone = Array.isArray(searchFilters._datetimezone) ? searchFilters._datetimezone[0] : searchFilters._datetimezone
    delete searchFilters._datetimezone
    delete searchFilters._activeTab
    delete searchFilters._sortKey
    delete searchFilters._sortOrder
    const timezone = searchFilterTimeZone || Helper.getLocalTimezone()
    Object.entries(searchFilters).forEach(([k, v]) => {
      if (!v) { delete searchFilters[k] }
    })
    const filtersQs = FilterHelper.processFilterFormSubmission({filterFormData: searchFilters, filterQueryData: this.state.searchText || '', timezone})

    this.apiData = {
      orgId: this.orgId,
      filterQs: filtersQs,
      ...AppHelper.getTeamBodyParams(this.orgId),
    }
    this.formDefinition = getExportFilteredFieldDef()
    this.setState({
      modalOpen: true
    });
  }

  onTabClick = (tabLabel) => {
    const selectedTab = this.state.availableTabs.find(tab => tab.label === tabLabel)
    if (!selectedTab) {
      return
    }

    const loadingMode = ApiHelper.LOADING_MODE.TABLE_LOAD

    const currentSearchText = this.state.searchText || ''
    const currentSearchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
    const currentFilterOptions = JSON.parse(JSON.stringify(this.state.filterOptions || []))

    const updatedSearchFilters = {
      ...currentSearchFilters,
      _activeTab: tabLabel,
    }
    delete updatedSearchFilters._sortKey
    delete updatedSearchFilters._sortOrder

    const isUniboxBtnEnabled = AppHelper.isCRMUniboxEnabled(this.orgId) &&
      selectedTab._sortKey === AppHelper.getUniboxSortKey(this.orgId)

    this.setState({
      activeTabLabel: tabLabel,
      isUniboxBtnEnabled,
      sortKey: selectedTab._sortKey || 'createdTs',
      sortOrder: selectedTab._sortOrder || 'desc',
      userSortKey: null,
      userSortOrder: null,
    }, () => {
      const hasAutoRefresh = selectedTab.active
      if (!hasAutoRefresh) {
        this.stopAutoRefresh()
        this.isAutoRefreshPausedByDialog = false
      } else if (this.state.isAutoRefreshEnabled) {
        if (this.isAnyDialogOpen()) {
          this.isAutoRefreshPausedByDialog = true
        } else {
          this.startAutoRefresh()
        }
      }
      this.onSearch(currentSearchText, updatedSearchFilters, currentFilterOptions, loadingMode, true)
    })

  }

  onUniboxBtnClick = (isUniboxBtnEnabled) => {
    const uniboxSortKey = AppHelper.getUniboxSortKey(this.orgId)
    const loadingMode = ApiHelper.LOADING_MODE.TABLE_LOAD
    const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions || []))

    const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters || {}))
    delete searchFilters._sortKey
    delete searchFilters._sortOrder

    const nextUserSortKey = isUniboxBtnEnabled ? uniboxSortKey : null
    const nextSortKey = isUniboxBtnEnabled ? uniboxSortKey : 'createdTs'

    this.setState({
      isUniboxBtnEnabled,
      userSortKey: nextUserSortKey,
      userSortOrder: null,
      sortKey: nextSortKey,
      sortOrder: 'desc',
    }, () => {
      if (!isUniboxBtnEnabled) {
        this.stopAutoRefresh()
        this.isAutoRefreshPausedByDialog = false
      } else if (this.state.isAutoRefreshEnabled) {
        if (this.isAnyDialogOpen()) {
          this.isAutoRefreshPausedByDialog = true
        } else {
          this.startAutoRefresh()
        }
      }
      this.onSearch(this.state.searchText || '', searchFilters, filterOptions, loadingMode)
    })
  }

  toggleSortOrder = () => {
    const newSortOrder = this.state.sortOrder === 'asc' ? 'desc' : 'asc';
    const searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters)) || {};
    const filterOptions = JSON.parse(JSON.stringify(this.state.filterOptions)) || [];

    searchFilters._sortOrder = newSortOrder;

    this.setState({
      sortOrder: newSortOrder,
      userSortOrder: newSortOrder,
      searchFilters
    }, () => {
      this.onSearch(this.state.searchText || '', searchFilters, filterOptions,ApiHelper.LOADING_MODE.TABLE_LOAD);
    });
  }

  getSortKeyLabel = () => {
    const sortKey = this.state.sortKey || 'createdTs'
    const sortOptions = this.buildSortOptionsFromFieldDef()
    const option = sortOptions.find(opt => opt.key === sortKey)
    return option ? option.label : 'Created Date'
  }

  buildSortOptionsFromFieldDef = () => {
    const defaultOptions = [
      { key: 'createdTs', label: 'Created Date' },
      { key: 'modifiedTs', label: 'Modified Date' },
      { key: 'activeIntSentTs', label:'Last Activity Date'}
    ]

    if (!this.fieldDef || !this.fieldDef.steps || !Array.isArray(this.fieldDef.steps)) {
      return defaultOptions
    }

    const dynamicOptions = []
    const addedKeys = new Set()

    for (const step of this.fieldDef.steps) {
      if (!Array.isArray(step.fields)) continue
      for (const field of step.fields) {
        if (field.type === 'dateTime' && field._uiKey) {
          const key = field._uiKey
          if (!addedKeys.has(key)) {
            dynamicOptions.push({
              key: key,
              label: field.label || key
            })
            addedKeys.add(key)
          }
        }
      }
    }

    return [...defaultOptions, ...dynamicOptions]
  }

  openSortByDialog = () => {
    const sortOptions = this.buildSortOptionsFromFieldDef()
    this.setState({
      isSortByDialogOpen: true,
      sortByFormDefinition: {
        title: 'Sort By',
        steps: [
          {
            fields: [
              {
                key: 'sortBy',
                type: 'select',
                label: 'Sort ContactsBy',
                options: sortOptions,
                v_required: { value: true, err: 'Please select a sort option' },
                defaultValue: (this.state.searchFilters || {})._sortKey || 'createdTs'
              }
            ]
          }
        ]
      }
    })
  }

  closeSortByDialog = () => {
    this.setState({ isSortByDialogOpen: false })
  }

  onList = () => {
    let searchFilters = JSON.parse(JSON.stringify(this.state.searchFilters)) || {}
    const preservedSearchFilters = ['_activeTab','_sortKey','_sortOrder']
    searchFilters = Object.fromEntries(
      Object.entries(searchFilters).filter(([key]) => preservedSearchFilters.includes(key))
    )
    if (!searchFilters._activeTab && this.state.activeTabLabel) {
      searchFilters._activeTab = this.state.activeTabLabel
    }
    const preservedUserSortKey = this.state.userSortKey || null
    const preservedUserSortOrder = this.state.userSortOrder || null
    const activeTab = this.getActiveTabConfig()
    const hasCustomTabs = Array.isArray(this.state.availableTabs) && this.state.availableTabs.length > 0
    const urlFilters = { ...searchFilters }
    delete urlFilters._sortKey
    delete urlFilters._sortOrder
    if (preservedUserSortKey && (!activeTab || !activeTab._sortKey)) {
      urlFilters._sortKey = preservedUserSortKey
    }
    if (preservedUserSortOrder && (!activeTab || !activeTab._sortOrder)) {
      urlFilters._sortOrder = preservedUserSortOrder
    }
    const nextSearchFilters = hasCustomTabs ? searchFilters : urlFilters
    CRMHelper.updateWindowUrl('', nextSearchFilters)
    const sortQueryParams = {}
    if (preservedUserSortKey) {
      sortQueryParams._sortKey = preservedUserSortKey
      if (preservedUserSortOrder || this.state.sortOrder) {
        sortQueryParams._sortOrder = preservedUserSortOrder || this.state.sortOrder
      }
    }
    if (preservedUserSortOrder) {
      sortQueryParams._sortKey =
      preservedUserSortKey || this.state.sortKey || 'createdTs'
      sortQueryParams._sortOrder = preservedUserSortOrder
    }
    this.toFetch[0] =  { key: 'crmcontacts', ms: AppConfig.CDP_MS.ENDPOINT, method: 'GET', paths: ['crmcontacts'], queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId), pb: 'fieldDef,fieldDefBulkRouteCrmContact', includeCustomFields: 'true', limit: 100, ...this.restrictViewCrmFilters, _datetimezone: Helper.getLocalTimezone(), _dateinterval: this.dateMap[this.defaultDateInteval.id], _aggTermsLimit: this.aggregationTermsLimit, ...sortQueryParams } }
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      searchText: '',
      searchFilters: nextSearchFilters,
      userSortKey: preservedUserSortKey,
      userSortOrder: preservedUserSortOrder,
    }, () => this.fetchItems())
  }

  openModalForProspect() {
    this.apiData = {
      orgId: this.orgId,
      creatorId: `${this.subOrgId || this.orgId}-${this.currentStaffUser.id}`,
      isProspect: true,
    }
    this.formDefinition = getProspectFieldDef(this.staffUsers, this.currentStaffUser, this.orgId, this.subOrgId)
    this.formDefinition.formType = 'add'
    this.formDefinition.title = Helper.getString('prospectContacts')
    this.setState({
      modalOpen: true
    });
  }

  openModalForAdd(fieldDef, apiData = {}) {
    this.apiData = {
      orgId: this.orgId,
      creatorId: `${this.subOrgId || this.orgId}-${this.currentStaffUser.id}`,
      ...apiData,
      ...AppHelper.getTeamBodyParams(this.orgId),
    }

    let fieldDefinition = null
    let isAddContactDialog = true
    if(fieldDef) {
      fieldDefinition = JSON.parse(JSON.stringify(fieldDef))
      isAddContactDialog = false
    } else if(this.fieldDef) {
      fieldDefinition = JSON.parse(JSON.stringify(this.fieldDef))
      fieldDefinition.title = Helper.getString('addContact')
    }

    const assigneeField = Helper.getField(fieldDefinition, 'assignee')
    if (this.currentStaffUser && this.currentStaffUser.id && assigneeField) {
      assigneeField.defaultValue = this.currentStaffUser.id
      assigneeField.value = assigneeField.defaultValue
    }
    if(isAddContactDialog && assigneeField && assigneeField.condition) {
      assigneeField.condition.clearDefaultValue = true
    }
    CRMHelper.normalizeAssigneeFieldValues(fieldDefinition, ['assignee'])
    const isImportDialog = !!Helper.getField(fieldDefinition, 'importCsv')
    if (!isImportDialog) {
      CRMHelper.populateAssigneeFieldOptions(fieldDefinition,this.subOrgs,this.orgId,this.teamsUnifiedView ? '' : this.subOrgId,true,this.staffUsers)
    }

    if(fieldDefinition && fieldDefinition.steps && fieldDefinition.steps.length > 0 && fieldDefinition.steps[0].fields) {
      fieldDefinition.steps[0].fields.forEach((field)=>{
        if(this.isMobileView && ['radio','check_box'].includes(field.type)) {
          field.disableTyping = true
        }
        if(field.key === 'state') {
          UiHelper.removeHiddenCrmContactStates(field, this.orgId)
          UiHelper.renameLeadStatusFieldOptions(field, this.orgId)
        }
      })
    }

    super.openModalForAdd(fieldDefinition)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'create-crm-contact'],
        queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') }
      }),
    });
  }

  async openModalForEdit(current) {
    this.apiData = {
      orgId: this.orgId,
    }
    const crmContactsStats = await CRMHelper.ensureCrmContactsStats({
      orgId: this.orgId,
      subOrgId: this.subOrgId,
      crmContactsStats: this.crmContactsStats,
    })
    const fieldDef = CRMHelper.buildCrmContactEditFieldDef(this.crmContactsResult.fieldDef, {
      orgId: this.orgId,
      isMobileView: this.isMobileView,
      crmContactsStats,
    })
    Helper.populateFormDefinitionValues(fieldDef, current)
    CRMHelper.populateAssigneeFieldOptions(fieldDef,this.subOrgs,this.orgId,this.teamsUnifiedView ? '' : this.subOrgId,false,this.staffUsers)
    super.openModalForEdit(current, fieldDef)
  }

  openModalForRoute(items) {
    const userIds = Array.isArray(items) ? items.map(u => u.userId) : items.userId
    const fieldDef = this.bulkRouteCrmContactFieldDef
    if(fieldDef) {
      fieldDef.formType = 'add'
      fieldDef.ctaButtonText = 'Route'
      fieldDef.title = Array.isArray(userIds) ? `Route ${userIds.length} ${userIds.length === 1 ? 'contact' : 'contacts'}` : 'Route contact'
      this.openModalForAdd(fieldDef, { userIds, _bulkRoute: true })
      this.setState({
        apiMethod: 'POST',
        apiEndPoint: ApiHelper.makeUrlPath2({
          ms: AppConfig.CDP_MS.ENDPOINT,
          paths: ['miscs', 'route-crm-contact'],
          queryParams: { orgId: this.orgId }
        }),
      })
    }
  }

  openModalForInfo(current) {
    this.apiData = {
      orgId: this.orgId,
    }
    let fieldDef = JSON.parse(JSON.stringify(this.crmContactsResult.fieldDef))
    fieldDef.title = (current.givenname || current.familyname)  ? Helper.formatName(current)  : (current.email || current.phone || Helper.getString('moreDetails') )
    CRMHelper.appendContactInfoDisplayFields(fieldDef, {
      orgId: this.orgId,
      isLeadRoutingEnabled: this.isLeadRoutingEnabled,
      crmContactsStats: this.crmContactsStats,
    })
    UiHelper.populateOptions(fieldDef, {items: this.staffUsers}, 'routedAssignee')
    const routedAssigneeField = Helper.getField(fieldDef, 'routedAssignee')
    if(routedAssigneeField) {
      routedAssigneeField.options.unshift({key: 'none', text: '[UNASSIGNED]'})
      routedAssigneeField.options.unshift({key: 'current-user', text: '[CURRENT USER]'})
    }
    UiHelper.populateOptions(fieldDef, {items: this.subOrgs}, 'routedSubOrgId')
    const routedTeamField = Helper.getField(fieldDef, 'routedSubOrgId')
    if(routedTeamField) {
      routedTeamField.options.unshift({key: 'none', text: '[UNASSIGNED]'})
    }
    fieldDef.tooltipFields = ['email','givenname','familyname','company','linkedinProfileUrl','assignee','jobTitle','friendlyname','friendlycompanyname','utmSource','utmMedium','utmCampaign','utmContent','utmTerm','sessionLandingPage','originalLandingPage']
    const accountsField = Helper.getField(fieldDef, 'accounts')
    if (accountsField) {
      accountsField.options.forEach(o => o.href = this.baseRoute() + '/crm-accounts/' + o.key)
    }
    const primaryAccountIdField = Helper.getField(fieldDef, 'primaryAccountId')
    if (primaryAccountIdField) {
      primaryAccountIdField.options.forEach(o => o.href = this.baseRoute() + '/crm-accounts/' + o.key)
    }

    const crmContactInfoFieldsCdpSettings = AppHelper.getSetting(this.orgId, 'CRM_CONTACT_INFO_FIELDS')
    if(crmContactInfoFieldsCdpSettings) {
      const crmContactInfoFields = crmContactInfoFieldsCdpSettings && crmContactInfoFieldsCdpSettings.split(',').map(item => item.trim()).filter(Boolean)
      if(crmContactInfoFields && crmContactInfoFields.length > 0) {
        fieldDef = Helper.getFilteredFieldDef(fieldDef, crmContactInfoFields)
      }
    }
    if (AppHelper.isABMEnabled(this.orgId) && this.accountFieldDef) {
      CRMHelper.appendAccountInfoFieldsToContactFieldDef(fieldDef, this.accountFieldDef)
    }

    if(fieldDef) {
      const accountsField = Helper.getField(fieldDef, 'accounts')
      if(accountsField) {
        accountsField.showOptionsChips = true
      }
      const primaryAccountIdField = Helper.getField(fieldDef, 'primaryAccountId')
      if(primaryAccountIdField) {
        primaryAccountIdField.showOptionsChips = true
      }

      const stateField = Helper.getField(fieldDef, 'state')
      if(stateField) {
        UiHelper.renameLeadStatusFieldOptions(stateField, this.orgId)
      }
    }

    this.setState({
      current: current
    })
    super.openModalForInfo(current,fieldDef)
  }

  onEdit(current) {
    CRMHelper.normalizeAssigneeFieldValues(this.formDefinition, ['assignee'])
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'update-crm-contact'],
        queryParams: { id: current.id, orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') }
      }),
    });
  }

  onActions = (current) => {
    const actions = []

    if (AppHelper.isEntityInPlaceDrillDown(this.orgId)) {
      actions.push(
        <Tooltip title={'Interactions'} placement='top-start' key={current.id + 'inPlaceDD'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={(e) => {
              e.stopPropagation()
              this.openInteractionsDialog(current)
            }}>contact_page</i>
          </span>
        </Tooltip>
      )
    }
    if(AppHelper.isCrmContactDrillDownButtonEnabled(this.orgId)) {
      actions.push(
        <Link to={this.baseRoute() + '/crm-contacts/' + current.userId} key={current.userId} onClick={(e) => e.stopPropagation()}>
          <Tooltip title='Detail Page' placement='top-start'>
            <span className={css(AppStyles.entityTableLinkIcon)}>
              <i className='material-icons-outlined'>arrow_forward_ios</i>
            </span>
          </Tooltip>
        </Link>
      )
    }
    return actions
  }

  onRowClick(current) {
    if(AppHelper.isCrmContactClickableEnabled(this.orgId)) {
      return this.openInteractionsDialog(current)
    }
    return null
  }

  handleActionsSelectChange = async (event) => {
    await this.updateLinkedinConnectionStatus(event.target.value)
  }

  updateLinkedinConnectionStatus = async (linkedinConnectionStatus) => {
    this.setState({
      fetchState: ApiHelper.State.LOADING,
      loadingMode: ApiHelper.LOADING_MODE.INSTANT_LOAD,
      inProcess: true
    })

    const apiEndPoint = ApiHelper.makeUrlPath2({
      ms: AppConfig.CDP_MS.ENDPOINT,
      paths: ['miscs', 'update-crm-contact'],
      queryParams: { id: this.state.current.id, orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') }
    })

    const apiPayload = {
      linkedinConnectionStatus
    }

    try {
      await ApiHelper.callAwait({
        method: 'POST',
        endPoint: apiEndPoint,
        jsonBody: apiPayload
      })

      this.setState(prevState => ({
        dialogApiData: {
          ...prevState.dialogApiData,
          responseBody: prevState.current
        },
        current: {
          ...prevState.current,
          linkedinConnectionStatus
        }
      }),()=>{
        this.fetchItem();
        this.setState({
          inProcess: false
        })
      })

    } catch (err) {
      this.setState({
        fetchState: ApiHelper.State.READY,
        loadingMode: ApiHelper.LOADING_MODE.PAGE_LOAD,
        inProcess: false,
        showToast: true,
        errMsg: Helper.getString('customerCareErr')
      })
    }
  }

  displayFieldActions = (item, fields) => {
    if(item && item.id === 'linkedinProfileUrl' && item.value) {
      const connectionStatusField = fields.filter(field => field.id === 'linkedinConnectionStatus')[0]
      return(
        <div className={css(Styles.fieldActionsContainer)}>
          {(!this.state.current.linkedinConnectionStatus || this.state.current.linkedinConnectionStatus === 'notrequested') && (<a href={Helper.toExternalHref(item.value)} target='_blank' rel='noopener noreferrer' className={css(Styles.link)} onClick={() => this.updateLinkedinConnectionStatus('connected')}>
            <AppButton
              buttonText={'Connect'}
              buttonStyle={Styles.connectButton}
              buttonTextStyle={Styles.connectButtonText}
              progressIconSize={16}
            />
          </a>)}
          {!this.state.inProcess && connectionStatusField && connectionStatusField.options && (<Select
            value={this.state.current.linkedinConnectionStatus || 'notrequested'}
            onChange={(event)=>this.handleActionsSelectChange(event, item)}
            disableUnderline
            MenuProps={{
              disablePortal: true,
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
              },
              classes: { paper: css(Styles.actionsSelectMenu) },
            }}
            classes={{ select: css(Styles.actionsSelection) }}
            className={css(Styles.actionsSelect)}
          >
            {connectionStatusField.options.map((option) => (
              <MenuItem key={option.key} value={option.key}>
                {option.label}
              </MenuItem>
            ))}
          </Select>)}
          {this.state.inProcess && <span className={css(Styles.actionCircularProgress)}>{UiHelper.itemLoadingView(25)}</span> }
        </div>
      )
    }
    return null
  }

  onMenuItems = (current) => {
    const actions = []
    const menuItems = []
    const isContactEnrollEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENROLL')
    const isContactEnrichEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH')
    const isContactEnrichPhoneEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH_PHONE')
    if(!this.isMobileView && !this.subOrgId) {
      if (isContactEnrollEnabled && current.email) {
        menuItems.push(
          {
            current: current,
            key: current.id + 'enroll',
            action: () => UiHelper.openModalForSequences.call(this, current, this.crmSequences, this.crmInboxes),
            title: 'Enroll',
            icon: <DynamicFeedOutlinedIcon/>,
          }
        )
      }
      if (isContactEnrichEnabled || isContactEnrichPhoneEnabled) {
        menuItems.push(
          {
            current: current,
            key: current.id + 'enrich',
            action: () => UiHelper.openModalForEnrich.call(this, current),
            title: 'Enrich',
            icon: 'dynamic_form',
          }
        )
      }
      if (this.isLeadRoutingEnabled) {
        menuItems.push(
          {
            current: current,
            key: current.id + 'route',
            action: () => this.openModalForRoute(current),
            title: 'Route',
            icon: 'fork_right',
          }
        )
      }
      menuItems.map(item => {
        actions.push(UiHelper.actionButton(item))
      })
    }
    return actions
  }

  checkBoxMenuActions = (checkedItems) => {
    const actions = []
    const menuItems = []
    const showExportButton = this.shouldShowExportButton()
    const isContactEnrollEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENROLL')
    const isContactEnrichEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENRICH')
    if (!this.subOrgId) {
      if (isContactEnrollEnabled) {
        menuItems.push(
          {
            key: 'enroll',
            action: () => UiHelper.openModalForSequences.call(this, checkedItems, this.crmSequences, this.crmInboxes),
            title: 'Enroll',
            icon: <DynamicFeedOutlinedIcon/>,
          }
        )
      }
      if (isContactEnrichEnabled) {
        menuItems.push(
          {
            key: 'enrich',
            action: () => UiHelper.openModalForEnrich.call(this, checkedItems),
            title: 'Enrich',
            icon: 'dynamic_form',
          }
        )
      }
      if (this.isLeadRoutingEnabled) {
        menuItems.push(
          {
            key: 'route',
            action: () => this.openModalForRoute(checkedItems),
            title: 'Route',
            icon: 'fork_right',
          }
        )
      }
      menuItems.push(
        {
          key: 'update',
          action: () => UiHelper.openModalForUpdate.call(this, checkedItems),
          title: 'Update',
          icon: 'edit',
        }
      )
      if (showExportButton) {
        menuItems.push(
          {
            key: 'export',
            action: () => UiHelper.openModalForExport.call(this, checkedItems),
            title: 'Export',
            icon: 'download',
          }
        )
      }
    }
    menuItems.map(item => {
      actions.push(UiHelper.actionButton(item))
    })
    return actions
  }

  checkBoxActions = (checkedItems) => {
    const headerActions = []
    const isContactEnrollEnabled = AppHelper.isSettingEnabled(this.orgId, 'CRM_CONTACT_ENROLL')
    if (this.subOrgId) {
      // tbd - jobs page needs to filter by suborg jobs
      /*headerActions.push(
        <Tooltip title={'Update'} placement='top-start' key={'update'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <i className='material-icons-outlined' onClick={() => UiHelper.openModalForUpdate.call(this, checkedItems)}>edit</i>
          </span>
        </Tooltip>
      )*/
    } else if (isContactEnrollEnabled) {
      headerActions.push(
        <Tooltip title={'Enroll'} placement='top-start' key={'enroll'}>
          <span className={css(AppStyles.entityTableLinkIcon)}>
            <DynamicFeedOutlinedIcon onClick={() => UiHelper.openModalForSequences.call(this, checkedItems, this.crmSequences, this.crmInboxes)}/>
          </span>
        </Tooltip>
      )
    }
    return headerActions
  }

  async customSubmitForProspecting(options) {
    const { formType, formData, caller } = options

    delete formData.isProspect

    ApiHelper.callAwait({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'create-prospect'],
        queryParams: {orgId: this.orgId},
      }),
      jsonBody: formData,
    }).then(response => {
      if (formData.prospectSource === 'csv') {
        if (response.csvUrl) {
          window.open(response.csvUrl, '_blank')
          caller.setState({
            fetchState: ApiHelper.State.READY,
          })
          this.setState({
            modalOpen: false,
          })
          return
        } else if (response.action === 'BULK_PROSPECT_CRM_CONTACTS') {
          window.open(this.baseRoute() + '/jobscrm', '_self')
          return
        } else {
          throw new Error('Csv not found')
        }
      }
      const fieldDef = JSON.parse(JSON.stringify(this.fieldDef))
      Object.keys(response.prospect).forEach(key => {
        const field = fieldDef.steps[0].fields.find(f => f.key === key)
        if (field) {
          field.defaultValue = response.prospect[key]
        }
      })
      const sourceKey = fieldDef.steps[0].fields.find(f => f.key === 'source')
      sourceKey.defaultValue = 'PROSPECTING'
      const stateKey = fieldDef.steps[0].fields.find(f => f.key === 'state')
      stateKey.defaultValue = 'PROSPECT'
      this.setState({ fetchState: ApiHelper.State.READY, modalOpen: false }, () => {
        const fieldDefinition = JSON.parse(JSON.stringify(fieldDef))
        fieldDefinition.title = Helper.getString('addContact')
        this.openModalForAdd(fieldDefinition, { createdBy: 'PROSPECT', prospectSource: formData.prospectSource })
      })
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async customSubmitForUpdate(options) {
    const { formType, formData, caller } = options
    formData.values = {}
    const removeAttrs = []
    const WHITELISTED_ATTRIBS = ['tags', 'assignee', 'timeZone', 'state', 'subOrgId','source']
    if (this.apiData && this.apiData._customFieldKeys && Array.isArray(this.apiData._customFieldKeys)) {
      WHITELISTED_ATTRIBS.push(...this.apiData._customFieldKeys)
    }
    WHITELISTED_ATTRIBS.forEach(a => {
      if (formData[a]) {
        if(['assignee','subOrgId'].includes(a) && (formData[a] === 'unassigned')) {
          removeAttrs.push(a)
        } else {
          const actualKey = (this.apiData._customFieldKeyMapping && this.apiData._customFieldKeyMapping[a]) ? this.apiData._customFieldKeyMapping[a] : a
          const customField = Helper.getCustomField(this.fieldDef, a)
          const isSelectMulti = customField && (customField.type === 'check_box' || customField.iType === 'SELECT_MULTI')
          const isUnset = Array.isArray(formData[a]) && formData[a].length === 0
          if (!(isSelectMulti && isUnset)) {
            formData.values[actualKey] = formData[a]
          }
        }
        delete formData[a]
      }
    })
    if(removeAttrs.length > 0) {
      formData.REMOVE_ATTRS = removeAttrs
    }
    delete formData._bulkUpdate
    const apiMethod = 'POST'
    const apiEndpoint = ApiHelper.makeUrlPath2({
      ms: AppConfig.CDP_MS.ENDPOINT,
      paths: ['miscs', 'update-crm-contact-bulk'],
      queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') },
    })
    ApiHelper.callAwait({
      method: apiMethod,
      endPoint: apiEndpoint,
      jsonBody: formData,
    }).then(response => {
      if (response._enrichResponse) {
        this.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false
        })
        this.onCompleteAction({
          apiInvokeData: {
            method: apiMethod,
            endPoint: apiEndpoint,
            reqBody: formData,
            responseBody: response,
          }
        })
      } else {
        window.open(this.baseRoute() + '/jobscrm', '_self')
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async customSubmitForRoute(options) {
    const { formData, caller } = options
    delete formData._bulkRoute
    const apiMethod = 'POST'
    const apiEndpoint = ApiHelper.makeUrlPath2({
      ms: AppConfig.CDP_MS.ENDPOINT,
      paths: ['miscs', 'route-crm-contact'],
      queryParams: { orgId: this.orgId },
    })
    ApiHelper.callAwait({
      method: apiMethod,
      endPoint: apiEndpoint,
      jsonBody: formData,
    }).then(response => {
      if (response._enrichResponse) {
        this.setState({
          success: true,
          message: Helper.getString('successful'),
          inProcess: false
        })
        this.onCompleteAction({
          apiInvokeData: {
            method: apiMethod,
            endPoint: apiEndpoint,
            reqBody: formData,
            responseBody: response,
          }
        })
      } else {
        window.open(this.baseRoute() + '/jobscrm', '_self')
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async customSubmitForExport(options) {
    const { formData, caller } = options
    const jsonBody = formData
    if (formData.mmyyyy === 'all_time') {
      delete formData.mmyyyy
      jsonBody.fromCreatedTs = 0
      jsonBody.toCreatedTs = Helper.currentTs()
    } else if (formData.mmyyyy === 'date_range') {
      const mode = formData.exportMode
      const tz = Helper.getLocalTimezone()
      const exportDateRange = formData.exportDateRange
      delete formData.exportDateRange
      delete formData.exportMode
      delete formData.mmyyyy
      let fromTs = 0
      let toTs = Helper.currentTs()
      if (exportDateRange && exportDateRange.startValue && exportDateRange.endValue) {
        fromTs = moment.tz(exportDateRange.startValue, tz).startOf('day').valueOf()
        toTs = moment.tz(exportDateRange.endValue, tz).endOf('day').valueOf()
      }

      if (mode === 'MODIFIED') {
        jsonBody.fromModifiedTs = fromTs
        jsonBody.toModifiedTs = toTs
      } else {
        jsonBody.fromCreatedTs = fromTs
        jsonBody.toCreatedTs = toTs
      }
    } else if (formData.mmyyyy) {
      delete formData.exportDateRange
      delete formData.exportMode
    }
    ApiHelper.callAwait({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-crm-contact'],
        queryParams: { orgId: this.orgId, ...(AppHelper.isTeamsUnifiedView(this.orgId) ? AppHelper.getTeamApiParams(this.orgId) : {}) },
      }),
      jsonBody: formData,
    }).then(response => {
      window.open(this.baseRoute() + '/jobscrm', '_self')
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }
  async customSubmitForSaveSegment(options) {
    const { formType, formData, caller } = options
    const jsonBody = JSON.parse(JSON.stringify(formData))
    let httpMethod = 'PUT', segmentIdPath = []
    if (formData._chosenSegment === '_new') {
      httpMethod = 'POST'
    } else {
      segmentIdPath = [formData._chosenSegment]
      delete jsonBody.title
    }
    ApiHelper.callAwait({
      method: httpMethod,
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['csegments', ...segmentIdPath],
        queryParams: {orgId: this.orgId},
      }),
      jsonBody,
    }).then(response => {
      caller.setState({
        fetchState: ApiHelper.State.READY,
      })
      this.setState({
        modalOpen: false,
        showToast: true,
        isErrorToast: false,
        toastMsg: 'Segment saved',
      })
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async customSubmitForSaveFilter(options) {
    const { formData, caller } = options
    const currentSettingString = AppHelper.getSetting(this.orgId, 'CRM_CUSTOM_FILTERS') || ''
    const currentFilters = CRMHelper.getCustomFilters(this.orgId,this.pageKey) || []

    const newQueryString = formData.filtersQs
    const filterName = formData._chosenFilter === '_new' ? formData.filterNickname : formData._chosenFilter

    const existingIndex = currentFilters.findIndex(f => f.label === filterName)
    if (existingIndex > -1) {
      currentFilters[existingIndex].value = newQueryString
    } else {
      currentFilters.push({ label: filterName, value: newQueryString })
    }

    const newSettingString = currentFilters.map(f => `${f.label}: ${f.value}`).join(' | ')

    CdpHelper.setSetting({
      orgId: this.orgId,
      settingsKey: 'CRM_CUSTOM_FILTERS',
      settingsValue: newSettingString,
      previousKey: 'CRM_CUSTOM_FILTERS',
      previousValue: currentSettingString
    }).then(response => {
      if (response.success) {
        caller.setState({
          fetchState: ApiHelper.State.READY,
        })
        this.setState({
          modalOpen: false,
          showToast: true,
          isErrorToast: false,
          toastMsg: 'Filter saved',
        })
      } else {
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: response.error,
          success: false,
          inProcess: false
        })
      }
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        inProcess: false
      })
    })
  }

  async customSubmitForExportFiltered(options) {
    const { formData, caller } = options
    const jsonBody = {
      orgId: this.orgId,
      filterQs: this.apiData.filterQs,
    }
    if (formData.title) {
      jsonBody.title = formData.title
    }
    Object.assign(jsonBody, AppHelper.getTeamBodyParams(this.orgId, 'staffSubOrgId'))
    if (!jsonBody.staffSubOrgId) {
      delete jsonBody.staffSubOrgId
    }
    ApiHelper.callAwait({
      method: 'POST',
      endPoint: ApiHelper.makeUrlPath2({
        ms: AppConfig.CDP_MS.ENDPOINT,
        paths: ['miscs', 'export-crm-contact'],
        queryParams: { orgId: this.orgId, ...(AppHelper.isTeamsUnifiedView(this.orgId) ? AppHelper.getTeamApiParams(this.orgId) : {}) },
      }),
      jsonBody,
    }).then(response => {
      window.open(this.baseRoute() + '/jobscrm', '_self')
    }).catch(err => {
      const errorMessage = Helper.getErrorMsg(err);
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      })
    })
  }

  async onFilterSubmit(options) {
    const { formType, formData, filterOptions, caller } = options
    const searchFilters = JSON.parse(JSON.stringify(formData));
    const updatedSearchFilters = CRMHelper.getUpdatedSearchFilters(filterOptions, searchFilters)
    const normalizeFilterKey = key => FilterHelper.getFilterBaseKey(key)
    const TAB_METADATA_KEYS = ['_activeTab', '_sortKey', '_sortOrder']
    const updatedNormalizedKeys = new Set(
      Object.keys(updatedSearchFilters || {}).map(normalizeFilterKey)
    )
    const filterDialogNormalizedKeys = new Set((filterOptions || []).map(f => normalizeFilterKey(f.key)))
    const underscoreSearchFilters = Object.keys(this.state.searchFilters || {})
      .filter(key => key.startsWith('_'))
      .reduce((acc, key) => {
        // Preserve tab metadata keys
        if (TAB_METADATA_KEYS.includes(key)) {
          acc[key] = this.state.searchFilters[key]
          return acc
        }
        const nk = normalizeFilterKey(key)
        if (updatedNormalizedKeys.has(nk) || filterDialogNormalizedKeys.has(nk)) {
          return acc
        }
        acc[key] = this.state.searchFilters[key]
        return acc
      }, {})

    const mergedSearchFilters = {...underscoreSearchFilters, ...updatedSearchFilters}
    this.setState({modalOpen: false })
    return this.onSearch(this.state.searchText, mergedSearchFilters, filterOptions)
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if ('seqEnrolmentNextStepIndex' in formData) { return UiHelper.customSubmitForSequences.call(this, options) }
    if (formData.isProspect) { return this.customSubmitForProspecting(options) }
    if (formData._bulkRoute) { return this.customSubmitForRoute(options) }
    if (formData.enrichFields) { return UiHelper.customSubmitForEnrich.call(this, options) }
    if (formData._bulkUpdate) { return this.customSubmitForUpdate(options) }
    if (formData.mmyyyy || formData.exportMode) { return this.customSubmitForExport(options) }
    if (formData._isMultiSelectExport) { return this.customSubmitForExport(options) }
    if (formData._chosenSegment) { return this.customSubmitForSaveSegment(options) }
    if (formData._chosenFilter) { return this.customSubmitForSaveFilter(options) }
    if (this.apiData && this.apiData.filterQs !== undefined) { return this.customSubmitForExportFiltered(options) }
    if (formData.importCsv) {
      if(formData && formData.updateExisting === 'YES' && formData.assignee) {
        delete formData.assignee
      }
      if (AppHelper.isABMEnabled(this.orgId)) {
        if (!formData.linkAccounts) formData.linkAccounts = 'YES'
        if (!formData.createNewAccounts) formData.createNewAccounts = 'YES'
        if (!formData.useEmailDomainAsAccountKey) formData.useEmailDomainAsAccountKey = 'NO'
      }
      try {
        await ApiHelper.callAwait({
          method: 'POST',
          endPoint: ApiHelper.makeUrlPath2({
            ms: AppConfig.CDP_MS.ENDPOINT,
            paths: ['miscs', 'create-crm-contact'],
            queryParams: { orgId: this.orgId, ...AppHelper.getTeamApiParams(this.orgId, 'staffSubOrgId') },
          }),
          jsonBody: formData,
        })
        window.open(this.baseRoute() + '/jobscrm', '_self')
        return
      } catch(err) {
        const errorMessage = Helper.getErrorMsg(err);
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        })
        return
      }
    }

    return caller.submit.call(caller, formData, true);
  }
}

const Styles = StyleSheet.create({
  enrichCreditsNotice: {
    color: 'green',
  },
  finderImportMessage: {
    fontSize: 16,
    lineHeight: 1.4,
    marginTop: 0,
    marginBottom: 0,
  },
  spanValue: {
    fontSize: 14
  },
  spanValueUniboxRead: {
    color: 'grey'
  },
  infoCellMobile: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 2,
  },
  infoFieldMobile: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '50vw'
  },
  cellWidthSmall: {
    width: '6%',
  },
  cellWidthNormal: {
    width: '40%',
  },
  line2: {
    fontSize: 10,
    color: 'grey'
  },
  statusBadge: {
    backgroundColor: AppTheme.primaryBg,
    // color: 'white',
    padding: 5,
    borderRadius: 10,
    wordBreak: 'keep-all',
    display: 'block',
    textAlign: 'center',
    maxWidth: 100,
  },
  lastWAMsgBadge: {
    backgroundColor: '#e0e0e0',
    color: '#222222',
    padding: 5,
    marginBottom: 5,
    borderRadius: 10,
    wordBreak: 'keep-all',
    display: 'inline-flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: 100,
    maxWidth: 400,
    '@media (max-width: 1024px)': {
      maxWidth: 250,
    },
    '@media (max-width: 767px)': {
      maxWidth: 100,
    },
  },
  lastWAMsgText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 100,
    maxWidth: 400,
    '@media (max-width: 1024px)': {
      maxWidth: 250,
    },
    '@media (max-width: 767px)': {
      maxWidth: 100,
      minWidth: 0,
      flex: 1,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
  },
  statusBadgeCustomer: {
    backgroundColor: '#3BDE86',
    color: '#222222'
  },
  uniBoxBadge: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: 15,
    fontWeight: 500,
  },
  dot: {
    backgroundColor: '#00C473',
    width: 8,
    height: 8,
    borderRadius: '50%',
    marginRight: 6,
    flexShrink: 0
  },
  uniBoxBadgeDot: {
    backgroundColor: '#00C473'
  },
  line3: {
    fontSize: 12,
    color: 'grey'
  },
  aboveTableContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  statContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: window.innerWidth - AppTheme.drawerWidth - (AppTheme.adminPagePadding * 2),
    '@media (max-width: 1024px)': {
      justifyContent: 'center',
      marginTop: 0,
      maxWidth: '97vw'
    },
    '@media (max-width: 767px)': {
      justifyContent: 'center',
      marginTop: 0,
      maxWidth: '95vw'
    },
    justifyContent: 'space-between',
    marginTop: 4,
    marginBottom: 6,
  },
  numericStatItem: {
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
    width: '20%',
  },
  numericStatItemRow: {
    '@media (max-width: 1024px)': {
      alignSelf: 'center',
      paddingTop: '8px',
      paddingBottom: '8px',
      height: '100%',
    },
    width: '100%',
  },
  pieStatItem: {
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingBottom: '16px',
    },
    width: '35%',
  },
  barStatItem: {
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingBottom: '16px',
    },
    width: '42%',
  },
  pieStatItemRow: {
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingBottom: '16px',
    },
    width: '35%',
  },
  barStatItemRow: {
    '@media (max-width: 1024px)': {
      width: '98%',
      alignSelf: 'center',
      paddingBottom: '16px',
    },
    width: '64%',
  },
  numericStatContainer: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    border: '1px solid ' + AppTheme.borderColor,
    padding: 16,
    margin: 0,
    borderRadius: AppTheme.borderRadius,
    gap: 5,
    //justifyContent: 'left',
    '@media (max-width: 1024px)': {
      border: 0,
      padding: '0px 0px',
      gap: 0
    },
  },
  numericStatContainerRow: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px 0px 8px 0px',
    margin: 0,
    gap: 5,
    //justifyContent: 'left',
    '@media (max-width: 1024px)': {
      padding: '2px 0px',
      gap: 0
    },
  },
  numericStatHorizontalContainer: {
    height: '100%',
    maxHeight: '100%',
    maxWidth: AppTheme.viewPort,
    display: 'flex',
    gap: 10
  },
  barChartContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  phoneValue: {
    cursor: 'pointer',
  },
  fieldActionsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 10,
    '@media (max-width: 767px)': {
      gap: 5
    },
  },
  connectButton: {
    color: AppTheme.buttonTextColor,
    backgroundColor: AppTheme.buttonBg,
    fontWeight: 600,
    padding: 7,
    fontSize: 14,
    textTransform: 'none',
    minWidth: 80,
    height: 25,
    marginBottom: 6,
    borderRadius: 6,
    '@media (max-width: 767px)': {
      minWidth: 80,
    }
  },
  connectButtonText: {
    color: AppTheme.buttonTextColor,
    fontWeight: 600,
    fontSize: 14,
    margin: 0,
    textTransform: 'none',
    '@media (max-width: 767px)': {
      fontSize: 12,
    },
  },
  actionsSelect: {
    minWidth: 140,
    paddingLeft: 10,
    paddingRight: 5,
    border: '1px solid #E5E5E5',
    textDecoration: 'none',
    borderRadius: 16,
    fontSize: 14,
    height: 25,
    marginBottom: 6,
    color: '#222222',
    '@media (max-width: 767px)': {
      minWidth: 110,
      fontSize: 12,
    },
  },
  actionsSelection: {
    color: '#222222',
    ':focus': {
      backgroundColor: 'inherit !important',
    }
  },
  actionsSelectMenu: {
    color: '#222222',
    marginTop: 3,
  },
  actionCircularProgress: {
    paddingBottom: 2,
    paddingLeft: 4
  },
  link: {
    textDecoration: 'none',
  },
  floatingActionButton: {
    position: 'fixed',
    bottom: 90,
    right: 14,
    zIndex: 1300,
    backgroundColor: AppTheme.buttonBg,
    color: AppTheme.buttonTextColor,
    boxShadow: 'none',
    ':active': {
      boxShadow: 'none',
    },
  },
  chartLabel: {
    fontSize: 10,
    color: 'grey'
  },
  tooltip: {
    zIndex: 9999999999
  },
  statsCardContainer: {
    maxWidth: 'unset',
    flex: 1,
  },
  statsCard: {
    width: '100%'
  },
  statsCardSmall : {
    width: '100%',
    height: 'auto',
    '@media (max-width: 1024px)': {
      width: '99%'
    },
    '@media (max-width: 767px)': {
      width: '99%'
    },
  },
  previewLabel: {
    fontWeight: 500
  },
  compactStatsTabsContainer: {
    marginTop: 8,
    marginBottom: 5,
  },
  autoRefreshContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 5,
    '@media (max-width: 480px)': {
      width: '100%',
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  sortByButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 8,
    '@media (max-width: 767px)': {
      marginTop: 8,
      marginBottom: 6,
    },
    '@media (max-width: 480px)': {
      width: '100%',
      marginTop: 6,
      marginBottom: 4,
    },
  },
  sortControlsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    marginTop: 12,
    marginBottom: 8,
    '@media (max-width: 767px)': {
      marginTop: 8,
      marginBottom: 6,
    },
    '@media (max-width: 480px)': {
      width: '100%',
      marginTop: 6,
      marginBottom: 4,
      gap: 4,
    },
  },
  sortControlsWithAutoRefresh: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    paddingTop: 8,
    paddingBottom: 8,
    marginTop: 4,
    marginBottom: 4,
    '@media (max-width: 767px)': {
      gap: 8,
    },
    '@media (max-width: 480px)': {
      width: '100%',
      gap: 6,
      paddingTop: 8,
      paddingBottom: 8,
      flexWrap: 'wrap',
    },
  },
  sortAndRefreshWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    paddingTop: 8,
    paddingBottom: 8,
    marginTop: 4,
    marginBottom: 4,
    '@media (max-width: 767px)': {
      gap: 8,
    },
    '@media (max-width: 480px)': {
      width: '100%',
      justifyContent: 'space-between',
      gap: 8,
      paddingTop: 8,
      paddingBottom: 6,
    },
  },
  sortButtonsGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginTop: 12,
    marginBottom: 7,
    '@media (max-width: 767px)': {
      marginTop: 8,
      marginBottom: 5,
    },
    '@media (max-width: 480px)': {
      marginTop: 6,
      marginBottom: 3,
      gap: 4,
    },
  },
  autoRefreshGroup: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: 5,
    '@media (max-width: 480px)': {
      paddingTop: 8,
      paddingBottom: 6,
    },
  },
  sortByButton: {
    height: 32,
    minWidth: 140,
    padding: '8px 16px',
    fontSize: 12,
    textTransform: 'capitalize',
    color: AppTheme.primaryColor,
    border: `1px solid ${AppTheme.borderColor}`,
    backgroundColor: 'transparent',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '@media (max-width: 480px)': {
      height: 36,
      minWidth: 100,
      padding: '10px 12px',
      fontSize: 10,
    },
  },
  autoRefreshLabel: {
    marginRight: 0,
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
      alignItems: 'center',
      marginLeft: 0,
    },
    '@media (max-width: 480px)': {
      width: '100%',
      flexDirection: 'row',
      marginRight: 0,
      marginLeft: 0,
    },
  },
  autoRefreshLabelText: {
    '@media (max-width: 1024px)': {
      fontSize: 10,
      marginTop: -6,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    '@media (max-width: 480px)': {
      fontSize: 11,
      marginTop: 0,
      textAlign: 'left',
    },
  },

  scrollableTabsContainer: {
    width: '100%',
    display: 'flex',
    gap: 8,
    paddingBottom: 8,
    marginBottom: 4,
  },

  sortOrderButton: {
    padding: '4px',
    marginLeft: '2px',
    color: AppTheme.primaryColor,
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
    '@media (max-width: 480px)': {
      marginLeft: '4px',
      padding: '4px',
    },
  },
  sortByButtonDisabled: {
    color: '#9e9e9e',
    border: '1px solid #d9d9d9',
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
    opacity: 1,
    textAlign: 'center',
  },
  sortOrderButtonDisabled: {
    color: '#9e9e9e',
    cursor: 'not-allowed',
    opacity: 0.65,
    textAlign: 'center',
  },
  sortAndAutoRefreshWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 16,
    marginTop: 12,
    marginBottom: 7,
    '@media (max-width: 767px)': {
      gap: 12,
      marginTop: 8,
      marginBottom: 5,
    },
    '@media (max-width: 480px)': {
      justifyContent: 'space-between',
      gap:0,
      marginTop: 6,
      marginBottom: 3,
      width: '100%',
    },
  },
  sortButtonsGroupCompact: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    flex: 'none',
    '@media (max-width: 480px)': {
      flex: 1,
    },
  },
  autoRefreshButtonGroup: {
    display: 'flex',
    alignItems: 'center',
    flex: 'none',
    '@media (max-width: 480px)': {
      marginLeft:'auto',
    },
  },
  actionButton: {
    height: 38,
    minWidth: 120,
    padding: 13,
    fontSize: 14,
    textTransform: 'capitalize',
    color: AppTheme.primaryColor,
    border: `1px solid ${AppTheme.borderColor}`,
    backgroundColor: 'transparent',
    borderRadius: 6,
    cursor: 'pointer',
    fontWeight: 500,
    ':hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
})